export default {
  date: {
    formats: {
      default: '%d/%m/%Y',
      short: '%e %B',
      long: '%-d %B %Y',
      with_day: '%A %-d %B',
      without_day: '%-d %B %Y',
    },
    day_names: [
      'dimanche',
      'lundi',
      'mardi',
      'mercredi',
      'jeudi',
      'vendredi',
      'samedi',
    ],
    abbr_day_names: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
    month_names: [
      null,
      'janvier',
      'février',
      'mars',
      'avril',
      'mai',
      'juin',
      'juillet',
      'août',
      'septembre',
      'octobre',
      'novembre',
      'décembre',
    ],
    abbr_month_names: [
      null,
      'jan.',
      'fév.',
      'mar.',
      'avr.',
      'mai',
      'juin',
      'juil.',
      'août',
      'sept.',
      'oct.',
      'nov.',
      'déc.',
    ],
    order: ['day', 'month', 'year'],
  },
  number: {
    format: {
      separator: ',',
      delimiter: '',
      precision: 3,
      round_mode: 'default',
      significant: false,
      strip_insignificant_zeros: false,
    },
    currency: {
      format: {
        format: '%n %u',
        unit: '€',
        separator: ',',
        delimiter: '',
        precision: 2,
        significant: false,
        strip_insignificant_zeros: false,
      },
      EUR: '€',
      USD: 'US$',
      CAD: 'cad',
      AUD: 'aud',
      GBP: '£',
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
    },
    percentage: {
      format: {
        delimiter: '',
        format: '%n%',
      },
    },
    precision: {
      format: {
        delimiter: '',
      },
    },
    human: {
      format: {
        delimiter: '',
        precision: 2,
        significant: true,
        strip_insignificant_zeros: true,
      },
      storage_units: {
        format: '%n %u',
        units: {
          byte: {
            one: 'octet',
            other: 'octets',
          },
          kb: 'ko',
          mb: 'Mo',
          gb: 'Go',
          tb: 'To',
          pb: 'Po',
          eb: 'Eo',
        },
      },
      decimal_units: {
        format: '%n %u',
        units: {
          unit: '',
          thousand: 'millier',
          million: 'million',
          billion: 'milliard',
          trillion: 'billion',
          quadrillion: 'million de milliards',
        },
      },
    },
    nth: {
      ordinals: {},
      ordinalized: {},
    },
  },
  datetime: {
    distance_in_words: {
      half_a_minute: 'une demi-minute',
      less_than_x_seconds: {
        one: 'moins de %{count} seconde',
        other: 'moins de %{count} secondes',
        few: 'Moins de %{count} secondes',
        many: 'Moins de %{count} secondes',
        zero: "moins d'une seconde",
      },
      x_seconds: {
        one: '%{count} seconde',
        other: '%{count} secondes',
        few: '%{count} secondes',
        many: '%{count} secondes',
      },
      less_than_x_minutes: {
        one: 'moins de %{count} minute',
        other: 'moins de %{count} minutes',
        few: 'moins de %{count} minutes',
        many: 'moins de %{count} minutes',
        zero: "moins d'une minute",
      },
      x_minutes: {
        one: '%{count} minute',
        other: '%{count} minutes',
        few: '%{count} minutes',
        many: '%{count} minutes',
      },
      about_x_hours: {
        one: 'environ %{count} heure',
        other: 'environ %{count} heures',
        few: 'environ %{count} heures',
        many: 'environ %{count} heures',
      },
      x_days: {
        one: '%{count} jour',
        other: '%{count} jours',
        few: '%{count} jours',
        many: '%{count} jours',
      },
      about_x_months: {
        one: 'environ %{count} mois',
        other: 'environ %{count} mois',
        few: 'environ %{count} mois',
        many: 'environ %{count} mois',
      },
      x_months: {
        one: '%{count} mois',
        other: '%{count} mois',
        few: '%{count} mois',
        many: '%{count} mois',
      },
      about_x_years: {
        one: 'environ %{count} an',
        other: 'environ %{count} ans',
        few: 'environ %{count} ans',
        many: 'environ %{count} ans',
      },
      over_x_years: {
        one: 'plus de %{count} an',
        other: 'plus de %{count} ans',
        few: 'plus de %{count} ans',
        many: 'plus de %{count} ans',
      },
      almost_x_years: {
        one: 'presque %{count} an',
        other: 'presque %{count} ans',
        few: 'presque %{count} ans',
        many: 'presque %{count} ans',
      },
      x_years: {
        one: '1 an',
        other: '%{count} ans',
      },
      x_weeks: {
        one: '1 semaine',
        other: '%{count} semaines',
        few: '%{count} semaines',
        many: '%{count} semaines',
      },
      x_hours: {
        one: '1 heure',
        other: '%{count} heures',
      },
    },
    prompts: {
      year: 'Année',
      month: 'Mois',
      day: 'Jour',
      hour: 'Heure',
      minute: 'Minute',
      second: 'Seconde',
    },
  },
  'custom-wallpaper': {
    'aria-title': 'Wallpaper',
    'aria-label': 'Set Wallpaper',
    'aria-author': 'author:',
  },
  page: {
    plus: {
      button: {
        text: 'Obtenir Pro',
      },
    },
    profile: {
      wallpapers: {
        best_1: "Jusqu'à cinq images différentes",
        best_2: 'JPEG ou PNG',
        best_3: "Jusqu'à %{size}",
        best_4: '%{resolution} pixels ou plus',
        best_5: 'Pas de GIF ou de vidéos (désolé)',
        best_title: 'Les critères :',
        text: "Mettez votre marque en valeur grâce à cinq vidéos ou images qui alternent en fond d'écran :",
        best_five: '%{videoResolution} pixels pour les vidéos',
        best_four: '%{resolution} pixels pour les images',
        best_one: "Jusqu'à cinq vidéos ou images",
        best_six:
          "Les fonds d'écran changent toutes les %{rotationInterval} secondes, les vidéos plus longues que %{rotationInterval} seront coupées",
        best_three: '%{size} max. par vidéo ou image',
        best_two: 'JPEG, PNG ou MP4',
        notice:
          "Roulement de tambours.... les fonds d'écran vidéo sont prêts !<a href='/profile'>Animez votre fond d'écran en vidéo</a>",
      },
      upsell: {
        benefit_one_alt: 'Obtenez votre propre page WeTransfer',
        heading_alt: 'Présentez votre travail avec style',
        benefit_one: 'Obtenez votre propre domaine WeTransfer',
        benefit_three: 'Créez vos propres e-mails de transfert',
        benefit_two:
          "Affichez des fonds d'écran personnalisés lors des téléchargements",
        button: {
          action: 'En savoir plus',
        },
        heading: 'Mettez votre marque en avant grâce à WeTransfer Pro',
      },
      branding: {
        headline:
          '<strong>Envoyez de la meilleure manière qui soit.</strong> Faites bonne impression à chaque fois que des gens téléchargent vos fichiers.<br /> <strong>Recevez en toute simplicité.</strong> Tout le monde peut vous envoyer des fichiers par transfert grâce à votre forfait.',
        protip: {
          text: "<strong>Conseil de pro :</strong> vous demandez à quelqu'un de faire un transfert ? Partagez un lien spécial pour pré-remplir la description.",
          link: 'En savoir plus',
        },
      },
      pagename: 'Paramètres du profil',
      'onboarding-step-two':
        "Présentez vos fichiers avec style, personnalisez votre profil WeTransfer et admirez votre nouveau look sur <a href='%{href}'>%{domain}</a>",
      email_backgrounds: "Fonds d'écran pour les e-mails",
      sent_you_files: 'Vous a envoyé des fichiers',
      email_background_instruction_with_spec:
        "Vos e-mails de transfert ne passeront plus inaperçus en ajoutant un fond d'écran.   \nPour de meilleurs résultats, utilisez une image de %{resolution} pixels (veuillez noter que nous aurons besoin de recadrer les images plus larges que ce format). La taille maximale du fichier est de %{size}.",
      receiving: 'E-mail du profil',
      choose_wallpapers: "Fonds d'écran",
      'step-one-banner':
        'Pour commencer, choisissez une URL pour votre page WeTransfer. Vous pourrez toujours la modifier ultérieurement.',
      description: {
        pro: 'Votre page WeTransfer vous permet de faire forte impression à chaque fois que des gens téléchargent vos fichiers. Et tout le monde peut vous envoyer des transferts de 200 Go, grâce à votre forfait WeTransfer Pro.',
        premium:
          'Votre page WeTransfer vous permet de faire forte impression à chaque fois que des gens téléchargent vos fichiers. Et tout le monde peut vous envoyer des transferts sans limite de taille de fichier, grâce à votre forfait WeTransfer Premium.',
      },
      'instructions-1':
        'Modifiez votre nom et votre URL autant de fois que vous le souhaitez.',
      'instructions-2':
        'Une fois que vous avez choisi une nouvelle URL, votre page sera immédiatement mise à jour.',
      title: 'Modifier votre page',
      profile_url: 'URL du profil',
    },
    payment: {
      never_actived_retry:
        'Votre compte n\'est pas encore actif. Terminez votre inscription pour commencer à utiliser <a href="/payment/retry">%{planName}</a>',
      pagename: 'Forfait et paiement',
      autorenew_heading: 'Informations de paiement',
      autorenew_notice:
        'Votre abonnement %{planName} de  %{deal} sera renouvelé automatiquement le %{autorenewal_attempt}.',
      will_expire_notice:
        "Votre abonnement Pro<span class='payment__notice'> expirera dans %{daysBetween} jours</span>. Renouvelez maintenant votre compte ou configurez votre renouvellement automatique.",
      never_actived_notice:
        'Votre compte n\'est pas encore actif.<a href="/payment/retry">Validez votre inscription pour commencer avec Pro.</a>',
      manual_renewal_expiry_notice: 'Votre compte Pro expirera le %{expiry}.',
      to_checkout: 'Payer',
      updating: 'Mise à jour...',
      yes_disable: 'Oui, continuer',
      review_billing_link: 'Mettre à jour votre moyen de paiement ?',
      autorenew_failed:
        "Votre abonnement Pro du %{deal}%{period} va <span class='payment__notice'><strong>expirer dans %{daysBetween}jours</strong>. Nous n'avons pas pu renouveler votre compte, veuillez renouveler manuellement votre compte avant <strong>%{expiry}</strong>.</span>",
      confirm_disable_autorenew:
        'Êtes-vous certain de vouloir arrêter le renouvellement automatique ?',
      disable_autorenewal: 'Arrêter le renouvellement automatique',
      enable_autorenewal: 'Activer le renouvellement automatique',
      renew_now: 'Renouveler maintenant',
      subscription_expired: 'Votre compte Pro a expiré',
      cancel_heading: 'Vous partez ?',
      cancel_info:
        'Ce sont des choses qui arrivent. Sans rancune ! Une fois votre abonnement annulé, nous conserverons vos fichiers 30 jours (mais pas sous notre oreiller, ça en deviendrait bizarre...) au cas où vous auriez oublié quelque chose en partant. Et vous pouvez réactiver votre abonnement à tout moment.',
      cancel_info_subscription:
        "Ce sont des choses qui arrivent. Sans rancune ! Une fois votre abonnement annulé, vous pourrez utiliser votre compte Pro jusqu'au %{subscriptionExpiryDate}. Ensuite, nous conserverons vos fichiers 30 jours  (mais pas sous notre oreiller, ça en deviendrait bizarre...) au cas où vous auriez oublié quelque chose. Et vous pouvez relancer votre abonnement à tout moment.",
      cancel_now: "Annuler l'abonnement",
      cancelling: 'Annulation...',
      confirm_cancel_subscription:
        'Êtes-vous sûr de vouloir vous désinscrire ?',
      confirm_reactivate_subscription:
        "Excellent choix ! Vous n'êtes plus qu'à un clic de la réactivation de votre mode de paiement",
      manual_renewal_in_future_notice:
        'Votre abonnement Pro de %{period}%{deal} arrive à expiration dans %{daysBetween} jours. Vous pouvez renouveler votre abonnement manuellement après %{manual_renewal_available_at} ou activer le renouvellement automatique maintenant.',
      reactivate_heading: 'Recommençons.',
      reactivate_content_top_pro:
        "Vous pouvez réactiver votre abonnement %{planName}, comme si vous ne l'aviez jamais annulé. Ou vous pouvez choisir de passer à WeTransfer Premium :",
      reactivate_content_top_premium:
        "Vous pouvez réactiver votre abonnement %{planName}, comme si vous ne l'aviez jamais annulé.",
      reactivate_content_bottom_pro:
        'Si vous passez à Premium, %{upfront_payment} vous seront facturés et vous pourrez commencer à utiliser WeTransfer Premium immédiatement. Votre nouvel abonnement de %{recurring_payment}/%{interval} sera renouvelé le %{recurring_date}.',
      reactivate_pro: 'Réactiver Pro',
      reactivate_premium: 'Réactiver Premium',
      reactivate_upgrade_to_premium: 'Passer à Premium',
      reactivating: 'Réactivation en cours...',
      subscription_cancelled:
        'Vous êtes désinscrit et votre compte expirera automatiquement dans %{daysBetween} jours.',
      subscription_reactivate_expired_notice: 'Votre compte Pro a été annulé.',
      subscription_reactivate_notice_pro:
        'Votre abonnement %{planName} a été annulé et arrivera à expiration dans %{daysBetween} jours.',
      subscription_reactivate_notice_premium:
        "Votre abonnement %{planName} a été annulé et arrivera à expiration dans %{daysBetween} jours.\nVous avez changé d'avis ? Pas de panique, il est facile de tout remettre en place.",
      subscription_reactivate_notice_trial_before:
        "Votre abonnement %{planName} a été annulé et arrivera à expiration dans %{daysBetween} jours.\nVous pouvez continuer à profiter de votre essai WeTransfer Premium jusqu'à la fin de votre abonnement.",
      subscription_reactivate_notice_trial_after:
        "Votre abonnement %{planName} a été annulé et arrivera à expiration dans %{daysBetween} jours.\nVous pouvez continuer à profiter de votre essai WeTransfer Premium jusqu'au %{trialExpiryDate}.",
      update_method_link: 'Mettre à jour les détails de paiement',
      autorenew_notice_teams:
        'Votre abonnement %{planName}  de %{deal} sera automatiquement renouvelé pour votre équipe de %{number_of_members} membres le %{autorenewal_attempt}.',
      cancellation_cta: "Annuler l'abonnement",
      cancellation_heading:
        "Vous n'avez plus besoin des avantages de %{planName} ?",
      cancellation_heading_trial: "Annuler l'abonnement",
      cancellation_text:
        "Si vous annulez votre abonnement, vous pourrez utiliser les fonctionnalités de Pro jusqu'au %{subscriptionExpiryDate}. Ensuite, votre compte WeTransfer Pro deviendra un compte gratuit et vos transferts existants expireront 28 jours plus tard.",
      cancellation_text_item_1:
        "Envoyer des transferts jusqu'à %{transfer_limit}",
      cancellation_text_item_2: 'Protéger vos transferts par mot de passe',
      cancellation_text_item_3:
        'Gérer et stocker %{storage_limit} de transferts',
      cancellation_text_item_4:
        'Utiliser votre URL et votre page Pro personnalisées',
      cancellation_text_item_heading:
        "Le compte gratuit ne vous permet d'envoyer que %{free_size_limit} par transfert. Vous ne pourrez plus :",
      cancellation_text_new:
        "Si vous annulez votre abonnement maintenant, vous pourrez utiliser %{planName} jusqu'au %{subscriptionExpiryDate}. Après cette date, vous repasserez au compte gratuit.<br /><br />Attention : vos transferts existants expireront 28 jours après la fin de votre abonnement, et pas un jour de plus.",
      cancellation_text_teams:
        "Si vous annulez votre abonnement maintenant, vous et votre équipe pourrez utiliser %{planName} jusqu'au %{subscriptionExpiryDate}.<br /><br />Après cette date, les membres de votre équipe et vous-même ne pourrez plus envoyer des transferts de fichiers, créer des présentations en diapos et des boards en équipe. Vous serez rétrogradé(e) au compte gratuit et vous pourrez uniquement vous connecter à votre propre compte WeTransfer.<br /><br />Attention : vos transferts existants expireront 28 jours après la fin de votre abonnement, et pas un jour de plus.",
      premium_trial: {
        feature_list_item_1: 'Aucune limite de taille pour les transferts',
      },
      premium_upgrade: {
        cta: 'Passer à Premium',
        description:
          'Un montant de %{upfront_payment} vous sera facturé, et vous pourrez commencer avec WeTransfer Premium sans attendre. Votre nouvel abonnement de %{recurring_payment}%{interval} sera renouvelé le %{recurring_date}.',
        feature_list_item_1: 'Envoyez des transferts sans limite de taille',
        feature_list_item_2: 'Stockage illimité',
        feature_list_item_3: 'Portails et avis illimités',
        feature_list_item_4: "%{storageLimit} d'espace de stockage",
        heading: 'Vous souhaitez passer au forfait supérieur ?',
      },
      unpaid_invoices: {
        heading: 'Vous avez des factures impayées',
        item: {
          issued_on: 'Émise le',
          pay_invoice: 'Payer la facture',
          pending_invoice: 'En attente...',
        },
        subheading:
          "Il semble y avoir un problème avec vos paiements précédents. Veuillez régler les factures en souffrance, sinon votre abonnement Pro risque d'être annulé.",
        subheading_2:
          'Si vous avez des factures en attente, veuillez patienter. Nous réessaierons dans quelques jours et la situation sera réglée une fois le paiement réussi.',
      },
      upgrade_cta: 'Mettre à niveau',
      app_subscription_banner: {
        title: 'Vous êtes abonné(e) à partir de %{app_name}',
        content:
          'Pour afficher ou gérer votre abonnement, connectez-vous à votre compte %{app_name} à partir de votre téléphone ou ordinateur.',
        go_to: 'Aller vers',
        learn_more: 'En savoir plus',
      },
    },
    'payment_cancel-verify': {
      cancellation_cta: "Annulation de l'abonnement",
      cancellation_disclaimer:
        '*Attention, vos transferts existants expireront 28 jours après la rétrogradation de votre compte, pas un jour de plus.',
      'current-plan': 'Forfait actuel',
      'free-forever': 'Libre à jamais',
      'free-usp-1': "Envoyez jusqu'à 2 Gb",
      'free-usp-2': 'Pas de stockage',
      'free-usp-3': 'Expiration des transferts après 7 jours*',
      'heading-free': 'WeTransfer',
      'heading-pro': 'WeTransfer Pro',
      intro:
        "Si vous annulez votre abonnement maintenant, vous pourrez encore utiliser WeTransfer Pro jusqu'au <b> %{expiration_date}</b> . Ensuite, vous repasserez au compte gratuit WeTransfer - ce qui est déjà bien, en soi.",
      pagename: 'Plus besoin des avantages de Pro ?',
      'pro-usp-1': "Envoyez et recevez jusqu'à %{transfer_limit}",
      'pro-usp-2': '1 Tb de stockage',
      'pro-usp-3': "Choisissez la date d'expiration des transferts",
      'pro-usp-4':
        '<p>Votre propre <a href="/profile?utm_source=pro_pass&utm_medium=usp_4_link&utm_campaign=cancel_verify">page Pro</a></p>',
      'pro-usp-5':
        '<a href="https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=usp_5_link&utm_campaign=cancel_verify"> Déverrouillez Paste® Pro et Collect Pro</a>',
    },
    payment_cancel: {
      info_with_end_date:
        '<p>Vous avez maintenant annulé votre abonnement, et vous repasserez au compte gratuit WeTransfer après le <b> %{ends_at}.</b></p>\n<p>Expliquez-nous la raison de votre départ et nous continuerons à améliorer WeTransfer Pro en pensant à vous.</p>',
      reason_header: 'Votre départ nous attriste',
      cancel: 'Retour',
      info: 'Expliquez-nous la raison de votre départ et nous continuerons à améliorer WeTransfer Pro en pensant à vous.',
      pagename: 'Avant que vous ne partiez',
      yes_disable: 'Oui, continuer',
    },
    payment_failed: {
      selected_product: 'Un %{duration} de %{planTier}',
      change: 'Mise à jour',
      complete_order: 'Valider votre commande',
      description: 'Vérifiez vos informations et terminez votre commande',
      description_error:
        'Un problème est survenu, vérifiez vos informations et continuez pour accéder au paiement',
      description_refused:
        "Nous n'avons pas pu effectuer votre paiement, veuillez vérifier vos informations de paiement et essayer de nouveau",
      discount: 'Remise',
      product_description: 'Un/Une %{duration} de WeTransfer Pro',
      title: 'Vous y êtes presque !',
      total: 'Total',
      vat: 'TVA',
      your_details: 'Vos informations',
      your_order: 'Votre commande',
      title_error: 'Désolé, il semble y avoir un problème',
      title_refused: 'Désolé, il semble y avoir un problème',
      payment_status_message:
        'Votre paiement a réussi mais une erreur est survenue, et nous n\'avons donc pas pu mettre à jour votre forfait automatiquement. <a href="https://wetransfer.zendesk.com/hc/en-us/requests/new" rel="external">Contactez l\'assistance</a>',
    },
    payment_methods: {
      billed_now: 'Facturé maintenant',
      info_content: {
        cancel_bullet:
          'Pas de panique, vous pouvez résilier en vous rendant dans Paramètres du compte > Paiement.',
        initial_payment_bullet:
          "Après le paiement initial, %{price} %{interval} vous seront facturés (sauf si vous décidez d'annuler votre abonnement, mais vous ne le feriez pas n'est-ce pas ? N'est-ce pas ?!)",
        update_payment_bullet:
          'Vous pouvez toujours mettre vos détails de paiement et/ou vos données de facturation à jour avant échéance du paiement suivant.',
        month:
          "- Après votre paiement initial %{price} vous seront facturés mensuellement, jusqu'à résiliation de votre abonnement Pro. \n- Vous pouvez résilier à tout moment en vous rendant dans Paramètres du compte > Paiement.\n- Vous pouvez toujours mettre à jour votre mode de paiement et/ou vos données professionnelles avant l'échéance du paiement suivant.",
        year: "- Après le paiement initial, %{price} vous seront facturés annuellement (sauf si vous résiliez votre abonnement WeTransfer Pro, mais ce n'est pas dans vos projets, si ? Si ?!)\n- Pas d'inquiétude, l'option d'annulation se trouve dans Paramètres du compte > Paiement.\n- Vous pouvez toujours mettre à jour votre mode de paiement et/ou vos données professionnelles avant l'échéance du paiement suivant.",
      },
      payment_cta: 'Finaliser le paiement',
      payment_term: {
        monthly: 'une fois par mois',
        yearly: 'une fois par an',
      },
      payment_title: 'Paiement',
      plan_details: {
        premium: 'WeTransfer Premium',
        pro: 'WeTransfer Pro',
        month: 'Mensuellement',
        year: 'Annuellement',
      },
      subtotal: 'Sous-total',
      legislation_text:
        'Ich fordere und stimme ausdrücklich zu, dass Sie mit der von mir bestellten Dienstleistung vor Ablauf der Widerrufsfrist beginnen. Mir ist bekannt, dass mein Widerrufsrecht mit vollständiger Vertragserfüllung erlischt.*',
      legislation_footer:
        '* Hier finden Sie die <a href="/legal/terms?overrideLanguage=de" target="_blank">Nutzungsbedingungen</a> und <a href="/documents/Datenschutz_und_Cookierichtlinie.pdf" target="_blank">Datenschutz- und Cookie-Erklärung.</a>',
      your_payment_method: 'Votre mode de paiement',
      bancontact: 'Bancontact',
      card: 'Carte de crédit',
      card_cvc: 'CVC',
      card_expiration: 'MM / AA',
      card_name: 'Nom figurant sur la carte',
      card_number: 'Numéro de carte',
      complete_payment: 'Finalisez votre paiement',
      creditcard: 'Carte de crédit',
      discount: 'Remise',
      do_not_refresh: 'Veuillez ne pas rafraîchir ni fermer cette page',
      ideal: 'iDEAL',
      ideal_info:
        'iDEAL est un mode de paiement néerlandais à travers lequel les utilisateurs peuvent passer par leur propre banque pour réaliser leur paiement.',
      info: 'Mise à jour du mode de paiement',
      payment_in_progress: 'Votre paiement est en cours de traitement...',
      paypal: 'PayPal',
      plan_name: 'WeTransfer Pro',
      price_period: {
        month: '/mois',
        year: '/an',
      },
      select_bank: 'Sélectionnez votre banque',
      select_country: 'Choisir le pays',
      sofort: 'SOFORT',
      tax: 'TVA',
      title: 'Choisissez votre mode de paiement',
      total: 'Total',
    },
    projects: {
      actions: {
        go_back: 'Tous les projets',
        discard: 'Annuler les modifications',
        edit: 'Éditer',
        remove_transfer:
          'Supprimer ce transfert ? Les fichiers seront supprimés de ce projet et des transferts envoyés.',
        save: 'Sauvegarder',
        share: 'Partager',
      },
      transfer_actions: {
        download: 'Télécharger',
      },
      added_at: 'à %{timeOfDay}',
      clipboard_modal: {
        copy_link: 'Copier le lien',
        link_copied: 'Lien copié dans le presse-papiers',
        content_label: 'Copier le lien dans ce projet',
        list_item_1: "Accès au téléchargement et à l'aperçu uniquement",
        list_item_2: 'Le lien restera toujours le même',
        title: 'Partager le projet',
      },
      content: {
        empty_state:
          'Votre projet est vide actuellement. Commencez par ajouter des fichiers pour débuter la chronologie de votre projet.',
      },
      logo_title: 'Revenir sur wetransfer.com',
      logo_tooltip_caption: 'Retour à WeTransfer',
      timestamp: 'il y a %{timeAgo}',
      chat: {
        owner_button_label: 'Psst… Dites-nous tout',
        owner_offline_greeting:
          "Nous sommes actuellement hors ligne, mais dites-nous ce qui vous pose problème et nous vous répondrons dans un délai d'un jour ouvrable.",
        owner_online_greeting:
          'Dites-nous ce qui vous pose problème et nous vous répondrons dans les plus brefs délais',
        receiver_button_label: 'Des questions ? Nous sommes là pour vous aider',
        receiver_offline_greeting:
          'Dites-nous ce qui vous pose problème et nous vous répondrons dans les plus brefs délais.',
        receiver_online_greeting:
          'Dites-nous ce qui vous pose problème et nous vous répondrons dans les plus brefs délais.',
      },
      created_by: 'Créé par %{user}',
      created_by_fallback: 'Créé',
      deliverable_clipboard_modal: {
        content_label: 'Copier le lien sur ce livrable',
        info: "D'autres personnes pourront également voir votre projet",
        title: 'Partager le livrable',
      },
      deliverables: {
        add_deliverable: 'Add a deliverable',
        add_files: 'Add files',
        cancel_upload: 'Cancel this upload?',
        clear_all_files_option: 'Clear all files',
        create_deliverable: {
          input_placeholder_0: 'Rough illustrations',
          input_placeholder_1: 'Brand guidelines',
          input_placeholder_2: 'Royalty-free SFX samples',
          input_placeholder_3: 'Color corrected video',
          input_placeholder_4: 'Voiceover recordings from my closet',
          input_placeholder_5: 'Quick sketches for quick approval',
          input_placeholder_6: '10,000 storyboard options',
          input_placeholder_7: 'The first video cut is the deepest',
          input_placeholder_8: 'Raw photos (for selection)',
          input_placeholder_9: 'My music reco (plus five lousy other options)',
        },
        create_deliverable_cancel: 'Cancel',
        create_deliverable_label: 'What will you deliver?',
        create_deliverable_save: 'Save',
        date: {
          updated_today: 'Updated today',
          updated_yesterday: 'Updated yesterday',
        },
        delete_option: 'Delete',
        deliverable_cleared:
          'Cleared all files from <strong><u>%{deliverableName}</u></strong>',
        deliverable_deleted:
          '<strong><u>%{deliverableName}</u></strong> has been deleted',
        deliverable_label: 'Deliverable',
        edit_option: 'Edit',
        edit_prompt: 'Rename this deliverable or add a description',
        empty_deliverable_state: 'No files yet. Coming soon',
        more_option: 'More',
        no_deliverables: {
          heading: 'Add a deliverable<br />to upload files',
        },
        no_deliverables_not_project_owner: {
          heading:
            '%{projectOwner} hasn’t added any deliverables for this project yet.',
        },
        processing_deliverable_state: 'Processing...',
        rename_option: 'Rename',
        share_option: 'Share',
        upload_cancel: 'Cancel',
        upload_files: 'Upload files',
        uploading: 'Uploading...',
        uploading_paused: 'Upload paused...',
        view: 'View',
      },
      errors: {
        blank: "Ce n'est pas le projet que vous recherchez…",
        limit:
          'Votre potentiel est infini, mais vous avez atteint votre limite de caractère',
        required:
          'Vous connaissez la chanson. Vous ne pouvez pas ignorer ce champ',
      },
      event: {
        project_created_byline:
          'Ajoutez des fichiers pour montrer ce sur quoi vous travaillez.',
        project_created_title: 'Début du projet',
      },
      file_count: {
        one: '%{count} fichier',
        other: '%{count} fichiers',
      },
      just_now: "à l'instant",
      labels: {
        description: 'Description',
        name: 'Nom',
        new_name: 'Donnez un nom à votre projet',
      },
      logo: {
        cta: 'Ajoutez un logo',
        errors: {
          dimensions:
            'Votre logo est plus petit que 220 x 220 px. Essayez une image plus grande',
          general: 'Oups, une erreur est survenue. Essayez à nouveau',
          size: 'Votre logo est plus grand que 5 Mo. Essayez un fichier plus petit',
          type: "Votre logo n'est pas un JPEG, GIF ou PNG. Essayez une autre image",
        },
        instructions:
          'Votre logo peut atteindre 5 Mo. Les JPEG et les GIF sont acceptables, mais les PNG avec un fond transparent conviennent mieux',
        'instructions-title': 'Montrez votre marque',
      },
      name_modal: {
        content_label: 'Nommez ou renommez votre projet',
        input_placeholder_0: 'Certainement une palme à Cannes',
        input_placeholder_1: 'Un remède pour le rhume',
        input_placeholder_2: 'Le crime parfait',
        input_placeholder_3: "J'écris des chansons, pas des titres",
        input_placeholder_4: 'Idée primée',
        input_placeholder_5: 'Nouvelle campagne de la marque',
        input_placeholder_6: 'Domination du monde',
        save: 'Enregistrer',
        text: 'Décrivez ce sur quoi vous travaillez.',
        title: 'Donnez un nom à votre projet',
      },
      new_project_label: 'Commencer un nouveau projet',
      noticebar: {
        'button-cancel': 'Annuler',
        'button-clear-all-files': 'Tout supprimer',
        'button-close': 'Fermer',
        'button-delete': 'Supprimer',
        'button-no': 'Non',
        'button-share': 'Partager',
        'button-yes': 'Oui',
        'confirm-cancel': 'Annuler ce transfert ?',
        'confirm-clear-files-deliverable':
          'Supprimer tous les fichiers de <strong><u>%{deliverableName}</u></strong> ?',
        'confirm-complete':
          'Téléchargement terminé ! Informez tout le monde que vous avez ajouté plus de fichiers.',
        'confirm-delete-deliverable':
          'Supprimer <strong><u>%{deliverableName}</u></strong> et les fichiers que vous y avez téléchargés ?',
        'confirm-first-complete':
          'Téléchargement terminé ! Partager ce projet pour vos fichiers à télécharger.',
        deliverable_not_found_error:
          'Hmm, on dirait que ce livrable a été supprimé',
        general_error: 'Oups, une erreur est survenue. Veuillez réessayer.',
      },
      'onboarding-promise': {
        description:
          'Décrivez tout le travail que vous réaliserez pour un projet et rationalisez la manière dont vous le partagez. Créez une liste de livrables, puis ajoutez des fichiers à mesure de votre progression, plus besoin de différents liens de téléchargement.',
        title: 'Commencez sur les clous pour rester sur les clous',
      },
      onboarding: {
        banner:
          "Votre attention s'il vous plaît ! Vous comptez parmi les rares personnes à avoir accès aux Projets pendant que cette section est en cours de construction (et d'amélioration). Il se peut que nous vous contactions pour recueillir vos impressions.",
      },
      pagename: 'Projets',
      placeholders: {
        description: 'Décrivez brièvement votre projet',
        loading: 'Chargement...',
      },
      project: {
        notification: {
          name_saved: 'Nom enregistré ! Votre projet semble être un champion.',
        },
      },
      share_button_label: 'Partager',
      unnamed_project_title: 'Projet sans nom',
      watch_video: 'Regarder la vidéo',
    },
    transfer: {
      display_name_fallback: 'Transfer sans titre',
      does_not_expire: "Aucune <u>date d'expiration</u>",
      expires_in: 'Expire dans <span>%{time}</span>',
      downloaded_at: 'Téléchargé %{date}, à %{time}',
      not_downloaded: 'Pas encore téléchargé',
      email_bounced: "L'adresse e-mail de votre destinataire ne fonctionne pas",
      count_files: {
        one: '%{count} fichier',
        other: '%{count} fichiers',
      },
      sent_datetime: 'Envoyé le %{date} à %{time}',
      never_expires: "Pas de date d'expiration",
      and_more: 'et %{count} plus',
      read_more: 'plus',
      copy_link: 'copier le lien',
      message: 'Message',
      total_downloads: 'Nombre des téléchargements',
      sent_to_recipients: {
        one: 'Envoyé à %{count} personne',
        other: 'Envoyé à %{count} personnes',
      },
      no_transfers:
        'Tous les transferts que vous avez envoyés apparaîtront ici ',
      add_first_description:
        'Vérifiez le statut des téléchargements, modifiez, transférez ou supprimez vos fichiers',
      mobile: {
        download: 'Télécharger tous les fichiers',
        remove: 'Supprimer le transfert',
      },
      delete_datetime: 'Fichiers supprimés le %{date} à %{time}',
      detail: {
        plus_download_stats:
          'Obtenez plus pour savoir combien de fois vos transferts ont été téléchargés.',
        plus_password_expiration:
          "Obtenez Pro pour ajouter un mot de passe et une date d'expiration à vos transferts.",
        plus_transfer_actions:
          'Obtenez plus pour gérer vos transferts et les supprimer à tout moment.',
        title: 'Les détails de vos transferts',
      },
      download_status_email: '%{count} sur %{total} personnes',
      download_status_email_text: {
        zero: 'Pas encore téléchargé',
        one: '%{count} sur %{total} personnes',
        other: '%{count} sur %{total} personnes',
      },
      download_status_link: {
        one: 'une fois',
        other: '%{count} fois',
      },
      download_status_link_text: {
        zero: 'Pas encore téléchargé',
        one: 'Une fois',
        other: '%{count} fois',
      },
      sent_moment: 'Envoyé le %{moment}',
      total_downloads_tooltip:
        'Vous ne vous attendiez pas à ça ? Nous avons récemment apporté une petite modification. Ce chiffre correspond uniquement aux téléchargements terminés.',
      display_name: {
        label: 'Titre',
        label_mobile:
          'Ajoutez un titre afin que les gens sachent ce que votre transfert contient',
      },
      download_status_received_text: {
        zero: 'Pas encore téléchargé',
        one: 'Téléchargé',
        other: 'Téléchargés',
      },
      edit_display_name: {
        cancel: 'Annuler',
        save: 'Enregistrer',
        title: 'Titre',
      },
      received_datetime: 'Reçu le %{date} à %{time}',
      received_from: 'Reçu de',
      received_moment: 'Reçu le %{moment}',
      teams: {
        received_by: 'Reçu par',
        self: 'moi',
        sent_by: 'Envoyé par',
      },
      title: 'Titre',
      set_password: {
        added: 'Ajouté',
        change: 'Modifier',
        remove: 'Supprimer',
        description:
          'Définissez un mot de passe pour contrôler qui a accès à ce transfert.',
        remove_warning:
          'Supprimer la protection par mot de passe de ce transfert ?',
        yes_remove: 'Oui, supprimer',
      },
      set_expiration: {
        description:
          "Définissez une date d'expiration pour limiter l'accès à ce transfert.",
        label: 'Expire le',
      },
      anon_upsell_no_account:
        'Pour modifier ou suivre les téléchargements de ce transfert avant son expiration, <a href="%{href}">inscrivez-vous</a> gratuitement.',
      anon_upsell_found_account:
        'Pour modifier ou suivre les téléchargements de ce transfert avant son expiration, <a href="%{href}">connectez-vous</a>.',
      anon_upsell_no_account_with_button:
        "Vous pouvez modifier ce transfert avant qu'il n'expire en créant un compte.",
      create_free_account: 'Créer un compte gratuit',
    },
    transfers: {
      space_used_unlimited: " %{space} d'espace occupé",
      pagename: 'Transferts',
      search: 'Chercher des noms de fichiers',
      search_results: {
        one: '%{count} résultat de recherche',
        other: '%{count} résultats de recherche',
        none: 'Aucun résultat',
        retry:
          "Nous n'avons pas trouvé de transfert correspondant à votre recherche - réessayez.",
      },
      space_used: '%{space} sur %{totalSpace} utilisé',
      selected_text: {
        one: '%{count} transfert sélectionné, %{size}',
        other: '%{count} transferts sélectionnés, %{size}',
      },
      last_7_days: 'Envoyé depuis les 7 derniers jours',
      over_7_days: 'Envoyé il y a plus de 7 jours',
      sort_on: 'Trier par :',
      size: 'Taille',
      name: 'Nom',
      date: 'Date',
      delete: 'Supprimer',
      download: 'Télécharger',
      forward: 'Transférer',
      remove: 'Supprimer',
      select: 'Sélectionner',
      copy_link: 'Copier le lien',
      sent_time_ago: 'Envoyé il y a %{timeAgo}',
      files: {
        one: '%{count} fichier',
        other: '%{count} fichiers',
      },
      confirm_transfer_delete:
        'Attention, êtes-vous sûr de vouloir supprimer ce transfert ?',
      confirm_forward:
        'Transférer remplacera le transfert en cours. Continuer ?',
      confirm_expired_transfer_delete:
        'Les fichiers et les renseignements de transfert seront supprimés définitivement. Êtes-vous sûr ?',
      deleting_now: 'Nous supprimons ceci pour vous tout de suite',
      deselect_all_transfers: {
        one: 'Désélectionner tous les transferts',
        other: 'Désélectionner les %{count} transferts',
      },
      downloads: 'Téléchargements',
      expiration: "Date d'expiration",
      expiration_next: 'Expire dans les %{days} à venir',
      expiration_no_date: "Aucune date d'expiration",
      expiration_not_soon: "N'expire pas prochainement",
      include_archived_switch_label:
        'Inclure les renseignements pour les transferts supprimés',
      include_archived_switch_tooltip:
        'Ils ne sont pas comptabilisés dans votre limite de stockage',
      notify_completed:
        "Transfert terminé. Vous pouvez fermer cette fenêtre, ou pas, c'est vous qui voyez.",
      preview: 'Prévisualiser',
      remove_permanently: 'Supprimer les renseignements définitivement',
      search_placeholder: 'Recherche par nom de fichier ou e-mail',
      select_all_transfers: {
        one: 'Sélectionner tous les transferts',
        other: 'Sélectionner les %{count} transferts',
      },
      space_left: '%{space} de%{totalSpace} gauche',
      teams_tip: {
        subtitle:
          'Cette page vous montre votre activité personnelle. Et au cas où vous vous posiez la question : les membres de votre équipe peuvent, eux aussi, voir uniquement leurs propres transferts.',
        title: 'Votre équipe Pro s’agrandit...',
      },
      title: 'Transferts envoyés',
      view_details: 'Plus de détails',
      edit_display_name: 'Modifier le titre',
      received_time_ago: 'Reçu il y a %{timeAgo}',
      search_title_placeholder: 'Cherchez par titre, nom de fichier, ou e-mail',
      see_all: 'Voir tout (%{count})',
      sender: 'Expéditeur',
      sort_by_title: 'Titre',
    },
    accountinfo: {
      pagename: 'Informations du compte',
      signed_in_as: 'Connecté en tant que %{name}',
      sign_out: 'Se déconnecter',
      paid_on: 'Payé le',
      no_invoices:
        "Vos reçus seront disponibles ici, mais il semble que vous n'en ayez pas encore eu. Quelle chance !",
      subscription_info:
        'Votre abonnement Pro à %{deal} sera renouvelé automatiquement le %{autorenewal_attempt}.',
      payment_success: {
        monthly:
          'Fantastique ! Vous êtes maintenant prêt à profiter de tout un mois de WeTransfer Pro.',
        monthly_renewal:
          "Fantastique ! Vous êtes maintenant prêt à profiter d'un nouveau mois de WeTransfer Pro.",
        yearly:
          'Fantastique ! Vous êtes maintenant prêt à profiter de toute une année de WeTransfer Pro.',
        yearly_renewal:
          "Fantastique ! Vous êtes maintenant prêt à profiter d'une nouvelle année de WeTransfer Pro.",
      },
    },
    changepassword: {
      pagename: 'Changer le mot de passe',
    },
    invoices: {
      pagename: 'Reçus',
    },
    reviewbilling: {
      pagename: 'Confirmer vos informations de paiement',
      information:
        'Afin de modifier votre moyen de paiement, nous devons également renouveler votre abonnement',
      information_payment:
        "Des frais de %{deal} vous seront facturés pour les prochains %{period} de Pro, votre abonnement sera valable jusqu'au %{expiry}",
    },
    renewbilling: {
      pagename: 'Vérifier vos informations et renouveler',
    },
    link_downloads_unsubscribe: {
      body: 'Vous pouvez désactiver les notifications concernant les téléchargements des transferts – tout en conservant un aperçu grâce à la fenêtre des liens envoyés',
      cta: 'Aller à mes transferts envoyés',
    },
    onboarding: {
      step_two: {
        wallpaper: {
          choose_button: 'Choisir dans la galerie',
        },
        next_button: "C'est bon",
        description:
          "Choisissez votre fond d'écran et décidez à quoi ressembleront votre profil et vos pages de téléchargement. Sympa non ? Vous pouvez télécharger le vôtre ou utiliser ceux que nous mettons à votre disposition.",
      },
      upload_wallpaper: {
        add_text: 'Télécharger une image',
        add_description:
          'Pour de meilleurs résultats, nous vous suggérons de télécharger une image au format 2560 x 1600 pixels. La taille maximum du fichier est de 3 Mo.',
        upload_text: 'Télécharger une image ou une vidéo',
      },
      preview: {
        wallpaper_credits_prefix: 'Papier peint par',
      },
      1: {
        description:
          '&quot;Personnalisez ce que les personnes voient chaque fois que vous leur envoyez des fichiers. Et avec votre propre page WeTransfer, tout personne peut vous envoyer %{transfer_limit} transferts, il vous suffit de lui indiquer votre URL. Votre adresse e-mail sera affichée sur la page pour que les personnes puissent avoir la certitude que leurs fichiers vous seront envoyés.<br /><br />\nCommencez par choisir votre URL.&quot;',
        next: 'Suivant',
        skip: 'Passer',
        warning:
          "<strong>Attention :</strong> vous ne pouvez le choisir qu'une seule fois (pas de pression !)",
        'blurb-1':
          "Créez votre propre page WeTransfer pour afficher un rendu professionnel à chaque fois que quelqu'un télécharge vos fichiers, et faites en sorte qu'il soit (encore) plus simple pour quiconque de vous envoyer des transferts.",
        'blurb-2': "Tout d'abord, choisissez votre URL.",
        welcome: 'Plantez le décor avec votre propre page WeTransfer',
        information:
          'Ne vous inquiétez pas, vous pourrez toujours la modifier plus tard dans <strong>Image de marque</strong>.',
        description_unlimited:
          "Personnalisez ce que les gens voient chaque fois que vous leur envoyez des fichiers. Et avec votre propre page WeTransfer, tout le monde peut vous envoyer des transferts, sans limite de taille - il suffit de leur transmettre votre URL. Votre adresse e-mail s'affichera sur la page, pour que les gens soient sûrs que leurs fichiers arriveront à bon port.<br /><br />\nTout d'abord, choisissez votre URL.",
      },
      2: {
        description:
          "Vous pouvez choisir jusqu'à cinq arrière-plans différents (ou fonds d'écran, comme nous les appelons) pour votre profil.\n\nMettez votre marque en valeur et transférez vos fichiers avec style.",
        pick: 'Faites votre choix dans notre galerie',
        title: 'Faites forte impression à chaque transfert',
        upload: 'Téléchargez le vôtre',
      },
      3: {
        description:
          '<strong>%{customLink}</strong> est en service. Vous pouvez désormais ajouter ce lien vers votre site Internet pour que les gens puissent vous envoyer des transferts %{transfer_limit} - ou vous pouvez, euh... envoyer des trucs.',
        done: 'Terminé',
        title: 'Voilà un beau profil',
        description_unlimited:
          '<strong>%{customLink}</strong> est en place. Vous pouvez désormais ajouter ce lien vers votre site internet pour que les gens puissent vous envoyer des transferts sans limite de taille - ou vous pouvez, euh… envoyer des trucs.',
      },
    },
    contact: {
      add_contact: 'Ajouter un contact',
      add_first_description:
        'Nous allons également sauvegarder les adresses e-mail auxquelles vous enverrez vos fichiers ici',
      add_to_transfer: 'Ajouter au transfert',
      remove_from_transfer: 'Retirer du transfert',
      confirm_delete: {
        one: 'Êtes-vous certain de vouloir supprimer ce contact ?',
        other: 'Êtes-vous certain de vouloir supprimer %{count} contacts ?',
      },
      contact_count: {
        one: '%{count} contact',
        other: '%{count} contacts',
      },
      edit: 'Modifier',
      mobile: {
        add: 'Ajouter un contact',
      },
      no_contacts: 'Ajouter votre premier contact ?',
      pagename: 'Contacts',
      remove: 'Supprimer',
      search_count: {
        one: '%{count} résultat de recherche',
        other: '%{count} résultats de recherche',
      },
      search_placeholder: 'rechercher un e-mail, un nom ou une société',
      select: 'Sélectionner',
      selected_text: {
        one: '%{count} contact sélectionné',
        other: '%{count} contacts séléctionnés',
      },
      teams_tip: {
        subtitle:
          "Lorsque vous envoyez un transfert, le destinataire est ajouté à votre liste de contacts. Chaque membre de votre équipe peut constituer son propre carnet d'adresses.",
        title: 'Votre équipe Pro s’agrandit...',
      },
    },
    unsubscribeexpiration: {
      button: 'Se désabonner',
      button_unsubscribed: 'Retourner sur WeTransfer',
      description:
        "Vous en avez assez de nos e-mails ? Pas de problème : nous cesserons de vous envoyer des messages lorsque vos transferts seront sur le point d'expirer.",
      description_unsubscribed:
        "Vous ne recevrez plus d'e-mails concernant l'expiration des transferts",
      no_email: 'vous',
      title: 'Se désabonner des e-mails de rappel',
      title_unsubscribed: "Et voilà, c'est fait !",
      downloaded: {
        body: "Entendu. Vous pouvez vous désabonner des rappels indiquant que vos transferts sont sur le point d'expirer lorsque vos fichiers ont déjà été téléchargés. Cela ne change rien aux envois de rappels pour les fichiers qui n'ont pas encore été téléchargés.",
        cta: 'Se désabonner',
        title:
          "\"Mes fichiers ont été téléchargés : je n'ai pas besoin d'e-mails concernant l'expiration des transferts\"",
      },
      not_downloaded: {
        body: "Aucun problème. Vous pouvez vous désabonner des rappels vous indiquant que vos transferts sont sur le point d'expirer, même si vos fichiers n'ont pas encore été téléchargés.",
        cta: 'Se désabonner',
        title:
          "Vous ne souhaitez pas recevoir d'e-mails sur l'expiration des transferts ?",
      },
      pro: {
        body_1:
          "Pas de problème, vous pouvez vous désabonner de ces rappels. Dans les détails de votre transfert, vous pourrez toujours garder une trace de la date d'expiration des transferts et la modifier quand vous le souhaitez.",
        body_2:
          'Psst, vous pouvez nous contacter à l\'adresse <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> si vous avez le moindre souci ou si vous changez d\'avis — sans rancune.',
        cta: 'Se désabonner',
        title:
          "Vous ne souhaitez pas recevoir d'e-mails sur l'expiration des transferts ?",
      },
    },
    about: {
      legal: {
        actionbar: {
          text: 'Êtes-vous sûr(e) de vouloir supprimer vos cookies ?',
        },
      },
    },
    about_plus: {
      checklist: {
        title: 'Passez à Pro sans attendre pour %{price} %{currency} par mois',
      },
    },
    advertise: {
      gallery: {
        preview: 'Prévisualiser',
      },
      guidelines: {
        advert_static: {
          title: "Fond d'écran statique",
        },
      },
    },
    billinginfo: {
      pagename: 'Informations concernant la facturation',
    },
    help: {
      button_all_answers: 'Plus de réponses',
      page_title: 'Assistance rapide',
      read_more: 'En savoir plus',
      search_button: 'Recherche',
      search_placeholder: 'Comment pouvons-nous vous aider ?',
    },
    payment_redirect_loader: {
      title: 'Just a moment',
      subtitle: 'Please resist the temptation to refresh or close this page',
    },
    payment_pending: {
      order_in_progress: 'En cours de chargement...',
    },
    payment_update: {
      bancontact: {
        info: "Pour info : pour s'assurer que vos détails sont corrects, Bancontact vous facture un montant unique de 0,50 €",
      },
      confirm_update: 'Confirmer',
      ideal: {
        info: "Pour info : pour s'assurer que vos détails sont corrects, iDEAL vous facture un montant unique de 0,01 €",
      },
      info: "Pour info : pour s'assurer que vos détails sont corrects, iDEAL vous facture un montant unique de 0,01 €",
      sofort: {
        info: "Pour info : pour s'assurer que vos détails sont corrects, SOFORT vous facture un montant unique de 1 €",
      },
      title: 'Mettre à jour les détails de paiement',
      update_in_progress: 'Mise à jour des détails...',
    },
    sign_in: {
      account: "Vous n'avez pas de compte ?",
      upgrade: 'Passer à WeTransfer Pro',
    },
    signin: {
      account_cta: 'Créer un compte',
      account_item_1: "Envoyez jusqu'à %{size_limit}",
      account_item_2: 'Gérer les transferts',
      account_item_3: "Stockez jusqu'à %{storage_limit}",
      account_subtitle: 'Gratuit',
      plus_cta: 'Obtenir WeTransfer Pro',
      plus_item_1: "Envoyez jusqu'à %{size_limit}",
      plus_item_2: 'Gérer les transferts',
      plus_item_3: "Stockez jusqu'à %{storage_limit}",
      plus_item_4: "Vos propres fonds d'écran",
      plus_item_5: 'Une URL personnalisée',
      plus_item_6: 'Des transferts protégés par mot de passe',
      plus_month: '/mois',
    },
    teams: {
      invitee: {
        action_cancel_invite: "Annuler l'invitation",
      },
      invitees: {
        title: "Invitation envoyée, en attente d'une réponse",
      },
      member: {
        action_demote: "Retirer le statut d'administrateur",
        action_promote: "Accorder le statut d'administrateur",
        action_revoke: "Retirer de l'équipe",
      },
      members: {
        title: 'Fait partie de votre équipe',
      },
      no_access: {
        description: "Restez à l'affût : on vous tiendra informé. ",
        title: 'Oups, cette fonction est encore top secrète. ',
      },
      subtitle: {
        members: {
          one: '%{count} membre',
          other: '%{count} membres',
        },
        pending: '%{pendingCount} invitations envoyées',
      },
      tip: {
        button: 'En savoir plus',
        subtitle:
          "Avec notre toute nouvelle fonctionnalité Pro for Teams, l'expérience WeTransfer est plus efficace que jamais ! Ajoutez de nouveaux membres gratuitement. Pour mettre sur pied votre équipe, utilisez le formulaire ci-dessous. C'est extrêmement simple : vous pouvez démarrer une fois les invitations acceptées !",
        title: 'Dans une équipe, il n\'y a pas de "je" qui tienne...',
      },
      title: 'Équipe',
    },
    transfer_progress: {
      meta: {
        expires_in: 'Expire dans %{expiry}',
      },
      recipients: 'Envoi en cours à',
      upsell: {
        benefit_one: 'Voir quand vos fichiers ont été téléchargés',
        benefit_three: 'Passer en revue et renvoyer vos anciens transferts',
        benefit_two: 'Voir qui a téléchargé vos fichiers',
        button: {
          action: 'En savoir plus',
          cancel: 'Non merci',
        },
        heading: 'Gérez vos transferts facilement avec WeTransfer Pro',
        title: 'Vos détails de transfert',
      },
    },
    transferReceived: {
      'empty-description':
        "Vous trouverez ici tous les transferts qui vous ont été envoyés — mais pas d'inquiétude, ils n'occupent pas votre espace de stockage",
      'empty-title': 'Suivi des transferts',
      empty: {
        description:
          "Vous trouverez ici tous les transferts envoyés à votre adresse e-mail ou téléchargés à votre attention - ne vous inquiétez pas, ils n'utiliseront aucune partie de votre stockage.",
      },
      banner: {
        freeUser: {
          text: "Procédez à une mise à niveau pour les recevoir facilement. Obtenez une URL personnalisée <strong>yourname.wetransfer.com</strong> et une page à l'image de votre marque pour les téléchargements.",
          link: 'En savoir plus',
          cta: 'Mettre à niveau',
        },
        paidUser: {
          withUrl: {
            text: 'N’importe qui peut vous envoyer des transferts de 200 Go à <strong>%{personalisedUrl}</strong>',
            cta: "Copier l'URL",
          },
          withoutUrl: {
            text: 'Définissez votre URL <strong>yourname.wetransfer.com</strong> et n’importe qui peut télécharger des fichiers à votre attention.',
            link: 'En savoir plus',
            cta: "Aller à l'image de marque",
          },
        },
      },
    },
    unsubscribeonboarding: {
      action: 'Se désinscrire',
      back: 'Retour à WeTransfer',
      contact:
        'Pst ! Si vous avez le moindre problème, écrivez-nous à l\'adresse <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> — sans rancune.',
      done: "C'est fini !",
      message:
        "Vous pouvez vous désinscrire de nos e-mails de présentation — pas d'inquiétude, vous continuerez à recevoir les messages importants.",
      title: 'Votre boîte de réception est trop chargée ?',
    },
    userinfo: {
      pagename: 'Détails personnels',
    },
    free_onboarding: {
      close: 'Fermer',
      finish_tour: 'Fait',
      next: 'Suivant',
      send_files: 'Envoyer des fichiers sans détour',
      start_tour: 'Regardez ce que nous avons encore en stock',
      step_one: {
        body_1:
          "Maintenant que vous avez vérifié l'adresse e-mail associée à votre compte, plus besoin de le faire à chaque transfert. Et plus de codes de vérification non plus !",
        body_2:
          'Gardez une trace de tous vos transferts envoyés et reçus au même endroit. Regardez combien de fois vos fichiers sont téléchargés. Renvoyez, transférez ou supprimez vos transferts en un clic.',
        header_1: 'Vérifié une bonne fois pour toutes',
        header_2: 'Gérez vos transferts',
        subtitle:
          "Dites au revoir aux codes de vérification et autres liens de téléchargement perdus. Votre nouveau compte est le meilleur moyen d'envoyer facilement de gros fichiers - gratuitement.",
        title_1: 'Envoyez des fichiers <strong>à votre guise</strong>',
        title_2: 'avec WeTransfer',
      },
      step_three: {
        body_1:
          "Que ce soit une vidéo sur votre téléphone ou un lien sur votre bureau, gardez toutes vos sources d'inspiration au même endroit. Pour commencer, ouvrez Collect à l'aide du launcher (le truc en haut à gauche) ou utilisez le lien suivant.",
        cta: 'Aller sur Collect',
        title_1: "<strong>Gardez de l'inspiration</strong> en route",
        title_2: 'avec Collect',
      },
      step_two: {
        body_1:
          "Présentez des idées. Dévoilez des travaux en cours. Restez en symbiose. Sans devoir formater des slides, encore et encore. Pour commencer, ouvrez Paste à l'aide du launcher (le truc en haut à gauche) ou utilisez le lien suivant.",
        cta: 'Aller sur Paste',
        title_1: 'Faites des <strong> slides en quelques secondes</strong>',
        title_2: 'avec Paste®',
      },
    },
    modal: {
      portals_intro: {
        cta: 'Découvrez les portails',
        pill: 'Une fonctionnalité flambant neuve',
        text: "Voici les <strong>portails</strong>, un moyen simple pour obtenir l'approbation dont vous avez besoin. Invitez des clients et collaborateurs à visualiser des fichiers et sélectionner des favoris - aucun téléchargement requis.",
        title:
          'Partagez vos travaux. Obtenez des réactions. Tout au même endroit.',
      },
    },
    not_found: {
      body: 'Retournez sur <a href="https://wetransfer.com/">wetransfer.com</a> ou égayez vos yeux avec quelques <a href="https://wepresent.wetransfer.com/">belles choses écrites par nos soins</a>.',
      image_alt: 'Une erreur est survenue',
      title: 'Oups, cette page est introuvable.',
    },
    password_and_security: {
      title: 'Mot de passe et sécurité',
      'two-factor-authentication': {
        description: {
          enabled: 'Depuis le %{date}',
        },
        disable: 'Désactiver',
        done: "C'est fait",
        enable: 'Activer',
        get_recovery_codes: 'Obtenir les codes de récupération',
        next_step: 'Suivant',
        recovery_code_action: 'Générer de nouveaux codes',
        recovery_code_keep_safe:
          "Chaque code a un usage unique, mais vous pouvez en obtenir d'autres si nécessaire.",
        recovery_code_need_more:
          "Vous avez besoin d'autres codes de récupération ? Vous pouvez toujours en générer de nouveaux, mais rappelez-vous qu'ils invalident les codes actuels.",
        recovery_code_title: 'Vos codes de récupération',
        require_password_action: 'Saisir',
        require_password_text: 'Saisissez votre mot de passe pour continuer',
        step_one_action: {
          app_store: "Télécharger dans l'App Store",
          google_play: 'Chercher sur Google Play',
        },
        step_one_label: 'Étape 1 (sur 3)',
        step_one_text:
          "Vous devez installer une application d'authentification sur votre téléphone. Si vous avez déjà Google Authenticator (ou une autre application), cliquez sur Suivant.",
        step_one_title: 'Télécharger Google Authenticator',
        step_three_label: "Étape 3 (c'est fini !)",
        step_three_text:
          "Si vous n'avez pas votre téléphone sur vous (il paraît que cela arrive) et que vous devez vous connecter, vous pouvez utiliser l'un de ces codes de récupération. Nous ne les conserverons pas et ne vous les transmettrons plus, donc notez-les bien - et veillez à les garder en lieu sûr au même titre que le code secret de votre compte en banque.",
        step_three_text_2:
          "Conservez ces codes avec le même soin que vos codes bancaires ! Chaque code ne peut être utilisé qu'une seule fois.",
        step_three_title: 'Enregistrer les codes de récupération',
        step_two_form: {
          error: 'Oups, ce code est erroné ou a expiré',
          label: 'Code de vérification',
        },
        step_two_label: 'Étape 2 (on est à la moitié)',
        step_two_text:
          "Utilisez votre application d'authentification pour scanner le code-barre. Elle générera un code de vérification à six chiffres : saisissez-le ci-dessous.",
        step_two_text_mobile:
          "Saisissez cette clé dans votre application d'authentification, qui générera un code de vérification à six chiffres : saisissez-le ci-dessous.",
        step_two_title: 'Scanner le code-barre',
        step_two_title_mobile: 'Saisir la clé',
        text: {
          protect_account:
            'Protégez votre compte par une sécurité supplémentaire grâce à votre téléphone.',
        },
        title: 'Authentification à deux facteurs',
      },
    },
    'payment-cancellation': {
      bundle: {
        title: 'Tirer le meilleur parti de Paste® et Collect',
      },
      cta: 'Non, je veux rester Pro',
      'cta-2': 'Résilier mon inscription',
      disclaimer: {
        collect:
          'Votre espace de stockage passera de 200 Go à 5 Go sur Collect',
        paste: 'Vous passerez de decks illimités à une limite de 3 sur Paste®',
        'team-member':
          'Vous serez retiré(e) de %{currentTeam} sur WeTransfer Pro.',
        teams:
          'Votre équipe de %{amountOfMembers} personnes sera supprimée de %{currentTeam} sur WeTransfer Pro.',
        title:
          'Quand votre abonnement actuel prendra fin le <strong>%{date}</strong> :',
        'transfer-expiry':
          'Vos transferts existants seront supprimés après 28 jours',
        'transfer-team-member':
          "Vous ne pourrez pas envoyer et recevoir de transferts dans le cadre de l'équipe, et vous ne pourrez pas gérer de transferts existants au sein de l'équipe.",
      },
      'password-expiry': {
        title:
          "Protéger vos transferts par mot de passe et fixer leur date d'expiration",
      },
      personalization: {
        title: 'Personnaliser votre propre page WeTransfer',
      },
      portals: {
        text: 'Avec %{planName}, vous pouvez utiliser les <a href="%{href}" target="_blank">portails</a> pour partager le travail que les clients doivent examiner. Aucun téléchargement n\'est nécessaire.',
        title:
          'Partager des travaux et recueillir des impressions au même endroit',
      },
      'stay-pro': "Conserver l'abonnement",
      'storage-limit': {
        title: 'Profiter de %{storage_limit_pro} de stockage par personne',
      },
      subtitle:
        'Si vous résiliez maintenant, dès le %{date} vous ne pourrez plus :',
      teams: {
        'individual-text':
          '<a href="%{href}" target="_blank">Invitez des membres de l\'équipe</a> à envoyer, recevoir et gérer des transferts ensemble, ou à travailler seuls gratuitement.',
        'team-member-text':
          'Vous serez retiré(e) de votre équipe et vous ne pourrez plus envoyer, recevoir ou gérer ensemble des transferts.',
        'team-owner-text':
          'Il y a <a href="%{href}" target="_blank">%{amountOfMembers}membres de l\'équipe</a> qui ne pourront plus envoyer, recevoir ou gérer ensemble des transferts.',
        title: 'Travailler à de grandes choses en équipe',
      },
      title: 'Êtes-vous vraiment prêt(e) à abandonner %{planName} ?',
      'transfer-limit': {
        text: 'En ce moment, vous pouvez envoyer et recevoir des transferts plus volumineux, beaucoup plus que les %{transfer_limit_free} gratuits.',
        title: 'Envoyer des transferts 100 fois plus gros',
      },
      'transfer-unlimited': {
        text: 'Vous pouvez envoyer (et recevoir) des transferts, sans limite de taille - infiniment plus que les %{transfer_limit_free} gratuits.',
        title: 'Envoyer des transferts de toute taille',
      },
    },
    pricing: {
      pro: {
        per_person: 'par personne',
      },
    },
    pricing_panel: {
      cta: {
        create_account: 'Créer un compte',
        current_plan: 'Forfait actuel',
        sign_up: "S'inscrire",
        switch_premium: 'Passer à Premium',
        switch_pro: 'Passer à Pro',
        upgrade: 'Mettre à jour',
      },
      faq: {
        answers: {
          answer_1:
            "Vous pourrez commencer à utiliser WeTransfer Pro ou WeTransfer Premium dès que votre paiement sera finalisé. Nous vous enverrons également un e-mail de confirmation avec votre facture payée.<br /><br /> \n\nUne fois en ordre, vous pourrez directement envoyer de gros transferts, utiliser les portails, et créer votre propre page WeTransfer. Si vous aviez déjà envoyé des transferts avec la version gratuite, vous pourrez en changer la date d'expiration à votre guise.",
          answer_2:
            "Quand vous utilisez WeTransfer, tout le monde peut télécharger vos fichiers - pas besoin de se connecter ou de s'inscrire. Le destinataire doit accepter nos Conditions d'utilisation, et peut-être nos cookies, mais cela s'arrête là !<br /><br /> \n\nSi vous souhaitez partager des travaux ou collaborer à travers des portails (la nouvelle fonctionnalité de WeTransfer), vos clients et collaborateurs ne devront pas s'inscrire pour visualiser, sélectionner, approuver ou télécharger des fichiers. Il vous suffira d'ajouter des membres d'équipe à votre compte Pro ou Premium pour permettre à d'autres d'ajouter des avis et de créer des portails avec vous.",
          answer_3:
            'Avec un forfait Pro ou Premium, vous pouvez créer votre propre page WeTransfer où chacun peut vous envoyer des fichiers dans les limites prévues par votre forfait. Vous pouvez ainsi recevoir des fichiers volumineux de la part de clients ou de collaborateurs sans qu\'ils doivent créer un compte pour autant - l\'URL de votre page suffit. (Ceci dit, il se peut que nous vérifions leur adresse e-mail pour vous protéger des "princes étrangers" qui "veulent vous envoyer de l\'argent").',
          answer_4:
            "Il faudra d'abord vous inscrire à WeTransfer Pro ou WeTransfer Premium - vous ne pouvez pas ajouter des membres d'équipe avec la version gratuite. Quel que soit le forfait de votre choix, les membres de votre équipe pourront tous bénéficier des mêmes avantages (vous ne pouvez pas souscrire à Premium tout en ayant quelques membres d'équipe sur Pro, par exemple). Les membres de l'équipe pourront envoyer et recevoir de gros transferts depuis votre page WeTransfer, et gérer des transferts depuis l'aperçu partagé unique.<br /><br /> \n\nUne fois que vous avez souscrit à la formule qui convient le mieux à votre équipe, vous pourrez inviter autant de membres d'équipe que vous voudrez depuis les paramètres de gestion d'équipe. Vous pouvez ajouter et supprimer des membres à tout moment, tant que votre abonnement est actif.",
          answer_5:
            "Nous acceptons PayPal et les cartes de crédit des grands groupes tels que Visa, Mastercard et American Express. Dans certains pays, nous acceptons également d'autres moyens de paiement en ligne.<br /><br /> \n\nNous n'acceptons pas les virements bancaires directs car il s'agit d'un abonnement annuel ou mensuel récurrent. (Nous vous enverrons un e-mail au préalable la première fois, afin de vous prévenir.)",
          answer_6:
            "Si vous ne bénéficiez pas du stockage illimité avec WeTransfer Premium, vous devrez soit faire de la place en supprimant quelques transferts envoyés, soit passer au forfait supérieur. À défaut, vous ne pourrez plus envoyer de nouveaux transferts.<br /><br /> \n\nSi vous utilisez la version gratuite de WeTransfer, tous vos transferts jusqu'à 2 Go seront automatiquement supprimés après 7 jours. Dans ce cas, pas de tracas : il vous sera impossible de dépasser la limite de stockage.",
          answer_6_variant_asterisk:
            "Vous devrez libérer de l’espace de stockage en supprimant certains de vos transferts envoyés ou mettre à niveau votre forfait. Tant que vous ne l'aurez pas fait, vous ne pourrez pas envoyer de nouveaux transferts. <br /><br />\n\nSi vous avez un abonnement Premium et atteignez 5 To, vous pouvez contacter notre équipe d’assistance et demander plus d'espace de stockage jusqu’à une limite annuelle maximale de 15 To. <br /><br />\n\nSi vous utilisez WeTransfer gratuitement, tous vos transferts envoyés d'une taille allant jusqu’à 2 Go sont automatiquement supprimés après 7 jours. Alors ne vous inquiétez pas, il ne vous est pas possible de dépasser votre limite de stockage.",
          answer_6_variant_limited_storage:
            "Vous devrez libérer de l’espace de stockage en supprimant certains de vos transferts envoyés ou mettre à niveau votre forfait (sauf si vous avez un abonnement Premium). Tant que vous ne l'aurez pas fait, vous ne pourrez pas envoyer de nouveaux transferts. <br /><br />\n\nSi vous utilisez WeTransfer gratuitement, tous vos transferts envoyés d'une taille allant jusqu’à 2 Go sont automatiquement supprimés après 7 jours. Alors ne vous inquiétez pas, il ne vous est pas possible de dépasser votre limite de stockage.",
          answer_7:
            "Votre abonnement sera automatiquement renouvelé (nous vous préviendrons par e-mail la première fois), mais vous pouvez le résilier à tout moment.<br /><br /> \n\nPour repasser à la version gratuite de WeTransfer, il vous suffit d'aller dans les paramètres de votre <strong>Compte</strong> et d'annuler votre abonnement. Vous (et tous les éventuels membres de votre équipe) pourrez continuer à utiliser Pro ou Premium jusqu'à échéance de votre forfait en cours.",
          answer_8:
            "Dans les quatre coins du monde, des millions de personnes font confiance à WeTransfer et à notre panel d'outils pour transmettre des idées. Rien que sur notre plateforme de partage, 80 millions d'utilisateurs partagent chaque mois 2 milliards de fichiers.<br /><br /> \n \nPour prévenir d'éventuelles attaques ou l'exploitation de vos idées, vos fichiers sont cryptés pendant le transfert (TLS) et le stockage (AES-256). Une fois stockés, vos fichiers ne sont uniquement accessibles via le lien unique envoyé à l'expéditeur et au destinataire.",
        },
        questions: {
          question_1:
            'Que se passe-t-il après mon inscription et le paiement ?',
          question_2: "Mes destinataires doivent-ils s'inscrire ?",
          question_3:
            'Puis-je recevoir des gros transferts de tout le monde ? ',
          question_4: "Comment ajouter (et supprimer) des membres d'équipe ?",
          question_5: 'Quel mode de paiement puis-je utiliser ?',
          question_6: 'Que se passe-t-il si je dépasse ma limite de stockage ?',
          question_7: 'Comment résilier ?',
          question_8:
            'Puis-je faire confiance à WeTransfer ? Quels sont les risques ?',
        },
        title: 'FAQ',
      },
      feature_table: {
        branding: {
          features: {
            advertising: 'Publicité (et art)',
            custom: 'Téléchargez la vôtre',
            feature_1: 'Personnalisez votre page WeTransfer',
            feature_2: "Fonds d'écran",
            feature_3: 'Personnalisez vos e-mails WeTransfer',
          },
          title: 'Mettez votre marque en valeur',
        },
        bundle: {
          collect: {
            storage: '%{collectStorageLimit} de stockage',
            title: 'Collect par WeTransfer',
          },
          paste: {
            limited_decks:
              "Jusqu'à %{pasteDecksLimit} decks avec le logo Paste par défaut",
            title: 'Paste® par WeTransfer',
            unlimited_decks: 'Decks illimités avec votre propre marque',
          },
          title: 'Complétez votre boîte à outils créative',
        },
        expiry: 'Les transferts expirent après %{days} jours',
        extra_storage: '%{storageLimit} supplémentaire par personne',
        monthly_price: '%{price} par mois par personne',
        portals: {
          features: {
            feature_1: 'Portails',
            feature_2: 'Avis',
            feature_3: 'Image de marque du client',
          },
          title: 'Partagez votre travail pour recevoir un retour et un accord',
        },
        security: {
          features: {
            feature_1: "Personnalisez les dates d'expiration",
            feature_2: 'Transferts protégés par mot de passe',
            feature_3: 'Cryptage de données',
            feature_4: 'Authentification à deux facteurs',
          },
          title: 'Sécurisez vos transferts',
        },
        storage_limit: '%{storageLimit} par personne',
        teams: {
          features: {
            feature_1: "Invitez des membres d'équipe",
            feature_2: 'Aperçu de transfert partagé',
            feature_3: 'Stockage partagé',
            feature_4: 'Image de marque partagée',
          },
          title: 'Livrez le travail en équipe',
          subtext: {
            text: 'Uniquement pris en charge si vous achetez un abonnement sur notre site web.',
            learn_more: 'En savoir plus',
          },
        },
        tooltips: {
          tooltip_1:
            'Tous les transferts envoyés sont comptabilisés dans votre stockage',
          tooltip_10:
            'Envoyez et stockez vos fichiers en toute sécurité grâce au cryptage TLS et AES-256',
          tooltip_11:
            'Suivez les téléchargements et gérez les transferts ensemble',
          tooltip_12:
            "Mettez votre travail (d'équipe) en valeur avec des fonds d'écran et des e-mails portant votre marque",
          tooltip_13:
            'Paste est un outil de présentation qui conçoit des decks pour vous avec des couleurs, un alignement et une mise en page adaptés',
          tooltip_14:
            "Collect vous permet de sauvegarder et d'organiser des images, des vidéos, de la musique et des liens sur tous vos appareils",
          tooltip_2:
            "Les personnes peuvent télécharger vos fichiers sans avoir à se connecter ou à s'inscrire",
          tooltip_3:
            "Gardez la trace de ceux qui ont (ou n'ont pas) téléchargé vos fichiers.",
          tooltip_4:
            'Organisez votre travail pour chaque client et chaque projet',
          tooltip_5:
            'Invitez les clients à visualiser et à sélectionner des fichiers, à ajouter des commentaires et à donner leur accord—sans avoir à télécharger quoi que ce soit.',
          tooltip_6:
            'Ajoutez un logo et un titre pour personnaliser vos portails pour chaque client.',
          tooltip_7:
            "Votre page WeTransfer est l'endroit où les personnes téléchargent vos fichiers et peuvent vous envoyer des transferts avec la limite de taille de votre plan",
          tooltip_8:
            "Les fonds d'écran sont les vidéos et les images qui apparaissent en arrière-plan lorsque vous envoyez et recevez des fichiers sur wetransfer.com",
          tooltip_9:
            "Wow, nous pensions que personne ne lirait ça—vous nous avez prouvé le contraire. Félicitations ! Les captures d'écran peuvent ou non être retweetées par @WeTransfer",
        },
        transfer_classic: {
          features: {
            feature_1: 'Taille limite de transfert',
            feature_2: 'Stockage',
            feature_3: 'Téléchargements sans compte',
            feature_4: 'Suivre les téléchargements',
            feature_5: 'Application iOS',
          },
          title: 'Envoyer des fichiers lourds',
        },
        unlimited: 'Illimité',
        yearly_price: '%{price} par an par personne',
      },
      header: {
        subtitle:
          'Que ce soit pour envoyer des fichiers volumineux pour le plaisir ou pour livrer un travail pour des clients—faites avancer vos projets créatifs avec WeTransfer.',
        title: {
          english_1: 'Vous avez les idées,',
          english_2: 'nous avons les forfaits',
          general: 'Plans et tarifs',
        },
      },
      plans: {
        billing: {
          discount: 'Économisez %{percentage} (ooh yeah)',
          discount_up_to: 'Save up to %{percentage} (ooh yeah)',
          monthly: 'Facturation mensuelle',
          yearly: 'Facturation annuelle',
        },
        free: {
          subtitle: 'Envoyer des fichiers de temps en temps',
          title: 'Gratuit',
          usp: {
            feature_1: "Envoyez jusqu'à %{transferLimit}",
            feature_2: 'Pas besoin de vérifier les transferts',
          },
        },
        premium: {
          subtitle: 'Partager votre travail sans aucune limite',
          title: 'Premium',
          usp: {
            feature_1: 'Pas de taille limite de transfert',
            feature_2: 'Stockage illimité',
            feature_2_subtitle:
              '* La limite initiale est de %{storageLimit}, avec la possibilité d\'ajouter de l\'espace de stockage supplémentaire sur demande. Une limite annuelle maximale de %{annualStorageLimit} s\'applique. Pour plus d\'informations, veuillez consulter nos <a href="/legal/terms" data-route-type="premium" target="_blank">conditions générales d\'utilisation</a>.',
            feature_3: 'Portails et avis illimités',
          },
        },
        pro: {
          subtitle: 'Envoyer des fichiers très volumineux régulièrement',
          title: 'Pro',
          usp: {
            feature_1: "Envoyez et recevez jusqu'à %{transferLimit}",
            feature_2: '%{storageLimit} de stockage par personne',
            feature_3: '%{portalsLimit} portail, avis illimités',
          },
        },
        tagline: {
          free: "pas d'argent, pas de problème",
          monthly: 'par mois par personne',
          yearly: 'par an par personne',
          per_person_monthly: 'par personne, facturé mensuellement',
          per_person_yearly: 'par personne, facturé annuellement',
          tax_included: 'taxe comprise',
        },
        title: 'Choisissez votre plan',
        month: 'mois',
      },
      skip_link: "Accéder à d'autres fonctionnalités",
    },
    pro_classic: {
      hero: {
        cta_1: "Plus d'infos",
      },
    },
    splashpage: {
      bundle: {
        title_new: 'Vous avez les idées, nous avons les plans',
      },
      cta: 'Je veux simplement envoyer des fichiers',
      free_panel: {
        cta: "S'inscrire",
      },
      plan: {
        free: {
          feature_1: "Envoyez jusqu'à <strong>%{transfer_limit}</strong>",
          feature_2: 'Pas de besoin de vérifier les transferts',
          subtitle_new: 'Pour les expéditeurs occasionnels de fichiers',
          title: 'Gratuit',
        },
        pro: {
          feature_1:
            "Envoyez et recevez jusqu'à <strong>%{transfer_limit}</strong>",
          feature_2: 'Fixez le délai d’expiration des transferts',
          feature_5: '1 To de stockage par personne',
          subtitle_new: 'Pour les professionnels et les équipes',
          title: 'Pro',
        },
      },
      reciever: {
        free: {
          cta: "S'inscrire maintenant",
          descripttion: 'Suivre les transferts',
          feature_1: "Envoyer jusqu'à 2 Go",
          feature_2: "Recevoir des transferts dans une seule vue d'ensemble",
          title: 'Gratuit',
        },
        pro: {
          cta: 'En savoir plus',
          descripttion: 'Tirez le meilleur parti de WeTransfer',
          feature_1: "Envoyez et recevez jusqu'à %{transfer_size}",
          feature_2:
            "%{storage_size} d'espace de stockage par personne pour les transferts",
          feature_3: 'Envoyer des transferts avec des paramètres personnalisés',
          title: 'Pro',
        },
        title:
          'Ne laissez pas les transferts se perdre dans votre boîte de réception.',
      },
      title: 'Tirez pleinement profit du nouveau WeTransfer',
    },
    teamsettings: {
      invite: {
        cta: 'Inviter une équipe',
        pagename: 'Inviter une équipe',
      },
      manage: {
        cta: 'Gérer une équipe',
      },
      members:
        'Il y a %{amountOfMembers} membres dans votre équipe. <a href="%{href}">%{cta}</a>',
      no_members:
        'Vous êtes seul pour l\'instant !<a href="%{href}">%{cta}</a>',
      settings: {
        pagename: "Paramètres de l'équipe",
      },
    },
    universal_onboarding: {
      team_feature: {
        subtitle: 'Faites équipe et transférez ensemble',
        context:
          "Faites équipe et envoyez et recevez des transferts en bénéficiant d'un espace de stockage partagé, d'une image de marque et d'un accès aux transferts de chacun.",
        invite_team: 'Inviter une équipe',
        dismiss: 'Peut-être plus tard',
      },
      feature_highlight: {
        free_context:
          "Vous pouvez à présent gérer les transferts envoyés et reçus en un seul aperçu. Savoir dès que les fichiers sont téléchargés. Renvoyer, transférer ou télécharger vos transferts en un seul clic. C'est si simple que ça",
        free_subtitle: 'Tous vos transferts au même endroit',
        paste_collect_link:
          'Aller sur <a href="%{pasteUrl}" rel="external">%{pasteName}</a> ou <a href="%{collectUrl}" rel="external">%{collectName}</a>',
        premium_context:
          "Vous pouvez maintenant envoyer des transferts de toute taille et créer votre propre <b>page WeTransfer</b> pour choisir ce que les personnes voient lorsqu'elles téléchargent vos fichiers. Prêt à choisir votre URL et vos fonds d'écran ?",
        premium_cta: 'Créer ma page',
        premium_dismiss: 'Peut-être plus tard',
        premium_subtitle: 'Créez votre page WeTransfer',
        premium_team_context:
          'Vous pouvez maintenant envoyer et recevoir des transferts de toute taille depuis la page WeTransfer personnalisée de votre équipe.',
        pro_context:
          "Vous pouvez maintenant envoyer jusqu'à %{transfer_limit} en une seule fois, et créer votre propre <b>page WeTransfer</b> pour choisir ce que les personnes voient lorsqu'elles téléchargent vos fichiers. Prêt à choisir votre URL et vos fonds d'écran ?",
        pro_team_context:
          'Vous pouvez maintenant envoyer et recevoir des transferts %{transfer_limit} depuis la <b>page WeTransfer personnalisée de votre équipe</b>.',
        send_cta: "Aller à l'envoi des fichiers",
        team_subtitle: 'Fournissez un travail créatif en équipe',
      },
      marketing: {
        context:
          'Maintenant que nous en savons un peu plus sur vous, nous vous en disons un peu plus sur nous. Vous voulez tout savoir sur la créativité et les dernières nouvelles de WeTransfer ?',
        image_alt_text:
          'Exemple du contenu des e-mails, y compris les caractéristiques des nouveaux produits, les rapports sectoriels et les articles WePresent qui racontent des histoires sur la créativité.',
        opt_in: 'Oui, volontiers',
        opt_out: 'Non merci',
        unsubscribe:
          'Vous pouvez toujours vous désabonner plus tard—sans rancune.',
      },
      welcome: {
        context:
          'Apprendre à mieux vous connaître nous aide à améliorer notre service.',
        cta: 'Continuer',
        dismiss: 'Ignorer',
        dropdown_options: {
          architecture: 'Architecture / Construction',
          data: 'Données / Finance / Légal',
          design: 'Conception / Illustration',
          education: 'Éducation / Stage',
          marketing: 'Marketing / RP',
          music: 'Musique / Son',
          other: 'Autre (et fier !)',
          photography: 'Photographie',
          product: 'Produit / Logiciel',
          sales: 'Ventes / Relations clients',
          video: 'Vidéo / Animation',
        },
        free_tier_title: 'Bienvenue sur WeTransfer, %{name}!',
        placeholder: 'Mmh, voyons voir...',
        question: "Tout d'abord, quel est votre domaine d'activité ?",
        team_title: "Vous faites maintenant partie de l'équipe, %{name} !",
        tier_title: 'Bienvenue sur WeTransfer %{tier}, %{name} !',
        data_opt_in: {
          checkbox_label:
            'Laissez WeTransfer utiliser les données que vous partagez pour vous montrer des publicités personnalisées sur nos sites web et en dehors.',
          tooltip_anchor: "Qu'est-ce que cela signifie ?",
          tooltip: {
            title: 'Comment WeTransfer utilise-t-il mes données ?',
            p1: "Nous utilisons votre adresse e-mail pour vous montrer (ainsi qu'à d'autres personnes comme vous) les publicités WeTransfer sur des sites web que vous consultez, tels que les réseaux sociaux.",
            p2: 'Nous exploitons également votre domaine de compétence pour vous offrir une expérience optimale sur nos sites web.',
            p3: 'Les données que vous choisissez de partager avec nous demeurent sécurisées à tout moment.',
            button: "J'ai compris",
          },
        },
      },
    },
    workspace_bar: {
      tooltip_text: "Ajoutez d'autres personnes à votre espace de travail",
      workspace: 'Espace de travail',
      manage_workspace: "Gérer l'espace de travail",
    },
  },
  exception: {
    activate_subscription_exception:
      'Une erreur est survenue : veuillez réessayer ou nous contacter via notre <a href="https://wetransfer.zendesk.com" rel="external">centre d\'aide</a>',
    complete_payment_exception:
      'Désolé, nous avons rencontré un problème, veuillez réessayer ou nous contacter via notre <a href="https://wetransfer.zendesk.com" rel="external">centre d\'aide</a>',
    retrieve_checkout_exception:
      'Une erreur est survenue : veuillez réessayer ou nous contacter via notre <a href="https://wetransfer.zendesk.com" rel="external">centre d\'aide</a>',
    source_id_error:
      "Désolé, nous n'avons pas pu traiter cette demande, veuillez réessayer",
    three_d_secure:
      'Nous ne prenons pas en charge les cartes 3D Secure pour le moment.',
    something_went_wrong:
      'Désolé, nous avons rencontré un problème, veuillez réessayer ou nous contacter via notre <a href="https://wetransfer.zendesk.com" rel="external">centre d\'aide</a>',
    signin_no_data_exception:
      "Désolé, nous avons rencontré un problème, veuillez vérifier votre nom d'utilisateur et votre mot de passe puis réessayez",
    signin_exception:
      "Désolé, nous n'avons pas réussi à vous connecter, veuillez réessayer",
    signout_exception:
      'Désolé, il semble que nous ne puissions pas vous déconnecter. Bizarre. Veuillez rafraîchir la page pour vérifier si vous êtes toujours connecté.',
    signup_account_error:
      'Désolé, quelque chose empêche votre connexion, veuillez vérifier vos informations et réessayer',
    retrieve_account_exception:
      'Désolé, cela ne fonctionne pas. Pardon de demander mais… pourriez-vous réessayer ?',
    update_account_error:
      'Désolé, nous ne pouvons pas mettre à jour vos informations de compte. Pouvez-vous réessayer ?',
    retrieve_subscription_exception:
      'Nous ne parvenons pas à identifier votre mode de paiement, veuillez réessayer',
    update_subscription_exception:
      'Nous n\'avons pas pu mettre à jour votre moyen de paiement, veuillez réessayer ou nous contacter via notre <a href="https://wetransfer.zendesk.com" rel="external">centre d\'aide</a>',
    autorenewal_not_supported:
      "Le renouvellement automatique n'est pas pris en charge pour ce compte",
    email_background_upload_validation_error:
      "Ce fichier est trop lourd ou n'est pas en format png ou jpg. Essayez avec une autre image.",
    email_background_upload_validation_error_videos:
      "Ce fichier est trop lourd ou n'est pas en format png ou jpg. Essayez avec une autre image.",
    update_password_exception:
      "Désolé, nous n'avons pas pu mettre à jour votre mot de passe, veuillez réessayer",
    retrieve_device_exception:
      "Nous ne trouvons pas d'appareils connectés. Meme pas un ! Veuillez réessayer.",
    remove_device_exception: 'Nous ne pouvons pas supprimer cet appareil',
    renew_subscription_exception:
      'Nous ne pouvons pas renouveler votre compte pour le moment, veuillez réessayer plus tard',
    invoices_retrieve_exception:
      "Nous n'avons pas pu trouver vos reçus, veuillez réessayer",
    invoice_download_exception:
      "Nous n'avons pas pu télécharger ce reçu, veuillez réessayer",
    image_not_valid:
      'Désolé, il semble que cette image ne puisse pas être téléchargée',
    update_profile_error:
      "Désolé, nous n'avons pas pu mettre à jour votre profil, veuillez réessayer",
    retrieve_profile_exception:
      "Nous n'avons pas trouvé vos paramètres de profil, veuillez réessayer",
    s3_exception:
      "Désolé, le téléchargement n'a pas fonctionné, veuillez réessayer",
    file_size_limit_reached:
      'La taille du fichier est trop grande, veuillez télécharger une image de 3 Mo ou inférieure',
    retrieve_transferlist_exception:
      "Nous n'avons pas réussi à trouver votre liste de transferts",
    retrieve_transfer_exception:
      "Nous n'avons pas réussi à trouver les informations du transfert",
    delete_transfer_exception:
      "Nous n'avons pas réussi à supprimer ce transfert",
    delete_transfers_exception:
      "Nous n'avons pas réussi à supprimer ces transferts",
    update_expiry_exception:
      "Cette date d'expiration n'a pas pu être mise à jour",
    add_contact_exception: "Nous n'avons pas pu ajouter ce contact",
    complete_last_order_exception:
      "Nous n'avons pas pu finaliser votre commande",
    edit_contact_exception: "Nous n'avons pas pu mettre à jour ce contact",
    remove_contact_exception: "Nous n'avons pas pu supprimer ce contact",
    request_password_reset_exception:
      "Désolé, nous n'avons pas pu effectuer cette demande de réinitialisation, veuillez réessayer",
    request_password_reset_no_user:
      "Cette adresse e-mail n'est pas reconnue, veuillez la vérifier puis essayer de nouveau",
    reset_password_error:
      'Nous avons rencontré un problème lors de la réinitialisation de votre mot de passe, veuillez réessayer',
    reset_password_exception:
      'Désolé, nous ne pouvons pas réinitialiser votre mot de passe pour le moment, veuillez réessayer',
    reset_password_token_invalid:
      'Désolé, le lien de réinitialisation ne fonctionne pas, veuillez suivre les instructions que nous vous avons envoyées par e-mail ou recommencez',
    retrieve_last_order_exception: "Nous n'avons pas trouvé votre commande",
    retrieve_ternot_exception:
      'Désolé, nous avons des difficultés à trouver votre transfert, veuillez essayer de nouveau',
    signin_invalid_credentials:
      'Cette adresse e-mail et ce mot de passe ne semblent pas correspondre, veuillez revérifier et essayez à nouveau',
    unsubscribe_expiration_exception:
      'Nous avons rencontré un problème lors de votre désabonnement, veuillez essayer de nouveau',
    unsubscribe_expiration_invalid_signature:
      'Désolé, le lien de désabonnement ne fonctionne pas, veuillez réessayer',
    cancel_subscription_exception:
      "Il semble qu'un problème soit survenu dans la résiliation de votre inscription. Veuillez réessayer plus tard.",
    payment_cancelled:
      'Désolé, nous avons rencontré un problème, veuillez réessayer ou nous contacter via notre <a href="https://wetransfer.zendesk.com" rel="external">centre d\'aide</a>',
    profile_picture_upload_validation_error:
      "Ce fichier est trop lourd ou n'est pas en format png ou jpg. Essayez avec une autre image.",
    reactivate_subscription_exception:
      'Une erreur est survenue, veuillez réessayer.',
    retrieve_contactlist_exception:
      "Nous n'avons pas trouvé votre liste de contacts",
    source_retrieve_error:
      'Désolé, nous avons rencontré un problème, veuillez réessayer ou nous contacter via notre <a href="https://wetransfer.zendesk.com" rel="external">centre d\'aide</a>',
    token_error: 'Il y a eu un problème. On réessaie ?',
    update_user_error:
      'Un problème est survenu pendant la mise à jour de vos informations',
    wallpaper_upload_validation_error:
      "Ce fichier est trop lourd ou n'est pas en format png ou jpg. Essayez avec une autre image.",
    wallpaper_upload_validation_error_videos:
      "Oups, il semble que votre vidéo n'est pas adaptée à nos exigences — réessayez",
    declined_contact_bank_error:
      "Désolé, nous n'avons pas pu procéder au paiement - veuillez contacter votre banque",
    invalid_password: 'Mot de passe non reconnu',
    otp_token_invalid: 'Oups, ce code est erroné ou a expiré',
    projects_load_exception:
      'Nous ne pouvons pas charger vos projets actuellement',
    update_information_throttle:
      'Un problème est survenu lors de la mise à jour de vos informations. Faites une pause de %{throttle_time} avant de réessayer.',
    price_amount:
      'The transfer price must be greater than %{currencySymbol}1.00 and less than %{currencySymbol}999',
    price_general_error_transfer_details:
      'The price could not be updated, please try again',
  },
  navigation: {
    about_us: {
      items: {
        products: 'Produits',
        plans_and_pricing: 'Forfaits et tarifs',
        pricing: 'Tarifs',
        pro_and_premium: 'WeTransfer Pro et Premium',
        about: 'WeTransfer',
        plus: 'Pro',
        apps: 'Apps',
        advertise: 'Publicité',
        upgrade: 'Mettre à niveau',
      },
      name_1_2019: 'Entreprise',
      name: 'Entreprise',
    },
    home: {
      name: 'Accueil',
    },
    help: {
      name: 'Aide',
    },
    got_plus: {
      name: 'Got Pro?',
    },
    signed_in: {
      name: 'Pro',
    },
    user: {
      items: {
        transfers: 'Transferts',
        contacts: 'Contacts',
        profile: 'Profile',
        account: 'Compte',
        received: 'Reçus',
        sent: 'Envoyés',
        teams: 'Équipe',
        projects: 'Projects',
      },
    },
    feedback: {
      name: 'Feedback',
    },
    sign_out: 'Se déconnecter',
    signin: {
      name: 'Se connecter',
    },
    branding: 'Image de marque',
    label: {
      beta: 'Bêta',
      new: 'Nouveau',
    },
    login: 'Se connecter',
    logout: 'Se déconnecter',
    portals: 'Portails',
    signup: "S'inscrire",
    features: {
      name: 'Caractéristiques',
      all: 'Toutes les fonctionnalités',
      file_sharing: 'Pour le partage de fichiers',
      collaboration: 'Pour la collaboration',
      security: 'Pour la sécurité des données',
      branding: "Pour l'image de marque",
      fast_feedback: 'Pour un retour rapide',
    },
    referral: 'Parrainer des amis',
    switcher: {
      create_free_account: 'Ajoutez gratuitement',
      just_you: 'Juste vous',
      team: 'Équipe',
      team_member_count: '%{amountOfMembers} membres',
    },
  },
  transfer: {
    bubble: {
      errors: {
        no_internet: "Hmm, vous n'êtes pas connecté(e) à Internet",
        begins_space:
          'Nous ne pouvons pas envoyer de fichiers dont les noms commencent par un espace. Veuillez les renommer et essayez de nouveau.',
        begins_stop:
          'Nous ne pouvons pas envoyer de fichiers dont les noms commencent par un point. Veuillez les renommer et essayez de nouveau.',
        blocked:
          "Nous n'avons pas pu lancer WeTransfer, il semblerait que vous soyez bloqué",
        generic:
          'Nous sommes désolé mais un problème est survenu lors de votre transfert',
        has_blackslash:
          'Nous ne pouvons pas envoyer de fichiers dont les noms comportent une barre oblique inversée. Veuillez les renommer et essayez de nouveau.',
        has_linebreak:
          'Nous ne pouvons pas envoyer de fichiers dont les noms comportent un saut de ligne. Veuillez les renommer et essayez de nouveau.',
        incorrect_recipient:
          "Il semble qu'une des adresses e-mails que vous avez entrée soit incorrecte",
        incorrect_sender:
          'Il semble y avoir un problème avec votre adresse e-mail',
        io_error: 'Il y a un problème avec vos fichiers',
        long_filename:
          'Nous ne pouvons pas envoyer de fichiers dont les noms contiennent plus de 250 caractères. Veuillez les renommer et essayez de nouveau.',
        long_message: 'Ce message est un peu trop long, veuillez le réduire',
        missing_default_recipient:
          'Vous pouvez uniquement envoyer plus de %{free_transfer_limit} aux adresses e-mail inscrites à WeTransfer Pro. Actualisez la page et recommencez.',
        no_clipboard: "Il semble que vous n'avez pas copié le lien",
        no_files:
          "Il semblerait que vous n'avez pas encore ajouté de fichiers !",
        no_folders:
          "Vous devez zipper/compresser votre dossier avant de l'envoyer",
        no_recipient:
          "Nous avons besoin de l'adresse e-mail à laquelle vous souhaitez envoyer ces fichiers",
        no_sender:
          'Maintenant, nous avons juste besoin de votre adresse e-mail et nous voila partis !',
        too_big:
          'Tout doux - nous ne pouvons pas transférer plus de %{upload_limit} en une fois',
        too_many_recipient:
          'Oups : notre limite est de %{count} personnes. Il vous en faut plus ? Pensez à transférer le lien.',
        unavailable:
          "Désolé, ce transfert a été supprimé et n'est plus disponible",
        wrong_password:
          "Oups, ce mot de passe n'est pas correct. Veuillez réessayer ou vérifier avec la personne qui vous a envoyée ce transfert ?",
        default_title: 'Oups !',
        duplicate_filename:
          'Nous ne pouvons pas envoyer plusieurs fichiers du même nom. Veuillez renommer vos fichiers puis essayez à nouveau.',
        firstaccept: "Vous devez approuver avant d'envoyer",
        not_downloadable:
          'Une erreur est survenue en essayant de récupérer vos fichiers. Veuillez recharger la page et réessayer.',
        recaptcha: {
          text: "Une erreur s'est produite. Réessayez !",
          title: 'Oups...',
        },
        too_big_text:
          "Il n'est possible de transférer que %{upload_limit} en une fois. Envoyez jusqu'à %{plus_limit} avec Pro. ",
        too_big_title: 'Le fichier est trop volumineux',
        too_many_files:
          'Vous ne pouvez actuellement pas envoyer plus de %{count} fichiers',
        too_many_recipient_text:
          'Pro vous permet de transférer des fichiers à 50 personnes maximum.',
        too_many_recipient_title: 'Il y a trop de destinataires',
        unavailable_forward:
          'Malheureusement il semble que ce transfert a été supprimé, il ne peut donc pas être transféré',
        verify: {
          button: 'Demander un nouveau code',
          text: 'Réessayez ou demandez un nouveau code. ',
          title: 'Oups !',
        },
      },
      buttons: {
        check_out: 'Afficher',
        help: "Centre d'aide",
        plus: 'Obtenez Pro',
        get_link: 'Obtenir le lien',
      },
      tips: {
        change_type:
          'Envoyez des fichiers par e-mail ou générez un lien de transfert dédié que vous pourrez partager selon vos envies',
        contacts:
          'Toute personne à qui vous envoyez des fichiers sera automatiquement ajoutée à vos contacts',
        expiry:
          "Avec WeTransfer Pro, c'est vous qui décidez de la date d'expiration de vos transferts. (Vous pouvez même la modifier après l'envoi !)",
        free_limit:
          "Bonne nouvelle, vous pouvez envoyer jusqu'à %{size} en une fois. Encore mieux, vous pouvez utiliser le service aussi souvent que vous le souhaitez !",
        message:
          'Vous pouvez ici ajouter un message à votre transfer si vous le souhaitez !',
        password:
          "Vous pouvez protéger vos transferts avec un mot de passe afin de renforcer leur sécurité. Veuillez noter que nous n'ajoutons pas de mot de passe dans l'e-mail, vous devrez donc le fournir aux bonnes personnes !",
        recipient_limit:
          "Ajoutez jusqu'à %{email_limit} e-mails ou ouvrez le menu à côté du bouton de transfert pour créer un lien",
        transfer_history:
          "Votre transfert est conservé dans l'aperçu de vos transferts",
        your_email:
          'Indiquez votre adresse e-mail ici, nous pourrons alors vous informer quand vos fichiers auront été téléchargés',
        link_transfer:
          'Saviez-vous que le lien de transfert était disponible ici  ?',
        previews_receiver:
          "Il est possible d'avoir un aperçu des images envoyées par les utilisateurs Pro avant leur téléchargement. Cliquez sur un fichier pour voir ce qu'il contient !",
        previews_sender:
          "Il est désormais possible d'avoir un aperçu des images que vous envoyez avant leur téléchargement",
        vrl_text:
          'Vous pouvez désormais prévisualiser vos fichiers sans les télécharger.',
        vrl_title: 'Voir vos fichiers',
        zip_text: 'Vous envoyez un dossier ? Nous le compressons pour vous',
        zip_title: 'Pas besoin de compresser',
        add_display_name_tooltip:
          "Donnez un titre à votre transfert afin que les gens sachent de quoi il s'agit. Cela vous aidera aussi à le retrouver par la suite.",
        anonymous_sender: {
          button: 'Obtenir un lien',
          text: 'Indiquez votre adresse e-mail ici pour que nous vous informions du téléchargement de vos fichiers.\n\nVous devrez vérifier votre adresse pour confirmer votre identité. Vous préférez éviter cette vérification à chaque fois ?',
          text_locked_recipient:
            'Indiquez votre adresse e-mail ici pour que nous vous informions du téléchargement de vos fichiers.\n\nVous devrez vérifier votre adresse pour confirmer votre identité.',
        },
        prefer_link: {
          button: 'Obtenir un lien',
          text: 'Vous préférez ne pas vérifier votre adresse e-mail ? Aucun souci.',
        },
      },
      button: {
        previews_receiver_learnmore: 'En savoir plus',
        previews_sender_learnmore: 'En savoir plus',
      },
      recipient_locked_text:
        "Cette page permet au propriétaire de recevoir des fichiers. Connectez-vous si c'est vous ou rendez-vous sur <a href=\"https://wetransfer.com\">wetransfer.com</a> pour les envoyer à quelqu'un d'autre.",
      recipient_locked_title: 'Attention !',
      title: {
        previews_receiver: 'Lancement des aperçus',
        previews_sender: 'Lancement des aperçus',
      },
    },
    download: {
      blocked: {
        link: 'En savoir plus',
        text: 'Ce transfert a été signalé et ne peut être téléchargé',
        title: 'Transfert bloqué',
      },
      title: 'Prêt ? Partez !',
      expires: 'Les fichiers expirent dans %{relative_time}',
      expires_never: "Aucune date d'expiration",
      files: '%{count} fichiers, %{size}',
      format: '%{files}・%{expires}',
      expand: 'plus',
      download_link: 'Lien du téléchargement',
      files_nosize: {
        one: '%{count} fichier',
        other: '%{count} fichiers',
      },
      show_all_files_mobile: 'Afficher tous les fichiers',
      zip_information:
        'Vous recevrez un fichier .zip lorsque vous téléchargerez tous les fichiers en une fois, <a href="https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device" rel="external">en savoir plus</a>',
      files_label: 'Files',
      message: 'Message',
      learn_more: 'en savoir plus',
      expires_in: 'Expire dans %{expiry}',
      download_all_zip:
        'La fonction « Tout télécharger » permet de télécharger tous les fichiers au format .zip',
      back_to_transfer: 'Retour au transfert',
      cookie_text:
        'Nous utilisons des cookies pour vous offrir la meilleure expérience possible. Mais ne vous inquiétez pas, nous ne vendons pas vos données à des tiers. Gérez vos <a href="https://wetransfer.com/legal/manage-cookies" rel="external">préférences de données</a>.',
    },
    preview: {
      open_grid: 'Aperçu',
      click_to_open: 'Cliquez pour un aperçu',
      grid: 'Fichiers dans ce transfert',
      link: 'Site internet',
      not_previewable: 'Aperçu indisponible',
      now_open: 'Aperçu ouvert',
      open_link: 'Ouvrir le lien dans un nouvel onglet',
      open_link_short: 'Ouvrir le lien',
      overview: 'aperçu',
      reload: 'Cliquez ici pour charger à nouveau',
      something_went_wrong: "Oups, une erreur s'est produite",
      tap_to_open: 'Aperçu',
      toobig_copy:
        'Seules les images dont la taille est inférieure à 50 Mo peuvent être prévisualisées  – <a href="https://wetransfer.zendesk.com/" rel="external">vous pourrez en apprendre plus ici</a>',
      toobig_title:
        'Désolé, cette image ne peut être prévisualisée : elle est trop lourde',
      unsupported_copy:
        'Lisez <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115003447483" rel="external">cet article</a> pour connaître les fichiers pris en charge.',
      unsupported_title: 'Aperçu (actuellement) indisponible pour ce fichier',
      visit_website: 'Aller sur le site internet',
    },
    complete_mobile: {
      email_text:
        "L'e-mail de transfert a été envoyé, votre transfert est disponible pendant %{expires}",
      link_text: 'Copiez votre lien de téléchargement :',
      email_text_no_expiry: 'Un e-mail a été envoyé au destinataire.',
    },
    'consent-manager': {
      art: {
        'short-v': {
          subtitle:
            "<b>Saviez-vous que 30% de nos espaces publicitaires sont réservés aux artistes ?</b> En acceptant nos cookies, vous nous autorisez à vous montrer quelques œuvres d'art et des causes qui nous sont chères, ainsi que quelques pubs primées qui ne se mettent pas en travers du chemin. ",
          text: 'Autorisez-vous également les cookies tiers de nos partenaires publicitaires, afin que nous puissions personnaliser les pubs que vous voyez ? ',
          title: 'Nos cookies alimentent la culture',
        },
        subtitle:
          "<b>Voilà pourquoi 30% de nos espaces publicitaires sont réservés aux artistes.</b> En acceptant nos cookies, vous nous autorisez à vous montrer quelques œuvres d'art et des causes qui nous sont chères, ainsi que quelques pubs primées qui ne se mettent pas en travers du chemin. ",
        text: "Notre site utilise des cookies qui contribuent à son bon fonctionnement, nous permettent de comprendre l'usage que vous avez de WeTransfer, et nous aident à nous améliorer. Autorisez-vous également les cookies tiers de nos partenaires publicitaires, afin que nous puissions personnaliser les pubs que vous voyez ?",
        title: "Nous sommes convaincus que l'art peut déplacer des montagnes",
        'title-small': 'Bienvenue sur WeTransfer',
      },
      'button-accept': "J'accepte",
      'button-accept-all': 'Tout accepter',
      'button-ccpa': 'Refuser la vente de vos informations personnelles',
      'button-cookies-privacy': 'Vos options de confidentialité',
      'button-reject': 'Non merci',
      'button-save': 'Enregistrer',
      'button-save-and-exit': 'Sauvegarder et fermer',
      'ccpa-banner-text':
        'Nous utilisons des cookies pour vous assurer la meilleure expérience sur notre site web. Mais ne vous inquiétez pas, nous ne vendons pas vos données à des tiers. Vous souhaitez refuser quand même ? <a href="%{href}">Gérer les paramètres</a>',
      'ccpa-body':
        "Comme vous vous trouvez aux États-Unis, vos droits sont protégés par le CPPA (California Consumer Privacy Act) et vous pouvez nous demander d'arrêter de vendre vos informations personnelles. Cela ne signifie pas que nous mettons vos informations personnelles ou vos fichiers privés aux enchères au plus offrant. Nous n'avons jamais fait cela et nous ne le ferons jamais ! Nous nous engageons à toujours avoir une longueur d'avance afin que votre empreinte numérique soit minime et que vous en gardiez le contrôle, en toute sécurité. Pour en savoir plus sur les données que nous recueillons et les raisons pour lesquelles nous les recueillons, veuillez consulter <a href=\"%{href}\">Vos choix en matière de confidentialité</a>.",
      'ccpa-donotsell': 'Ne pas vendre mes informations personnelles',
      'ccpa-header': 'Refuser la vente de vos informations personnelles',
      'ccpa-intro':
        "En tant que société technologique responsable qui s'engage pour un Internet meilleur, nous ne vendons pas vos données à des tiers. Mais vous avez de toute façon le droit de formuler votre refus officiel.",
      'ccpa-variant-test-text':
        'Nous utilisons des cookies pour que vous puissiez naviguer sans difficulté sur notre site internet et pour personnaliser les publicités que vous voyez. <a href="%{href}">Gérer les cookies</a>',
      headline: 'Cookies et publicité',
      intro:
        "L'argent que nous gagnons grâce à nos magnifiques publicités sert à payer nos factures. Ces rentrées nous permettent de fournir un service de partage de fichiers en toute gratuité.",
      'manage-cookies': 'Gérer les cookies',
      'partners-consent': 'Accepter',
      'partners-features': 'Caractéristiques',
      'partners-headline': 'Nos partenaires',
      'partners-text':
        '<p>Voici une liste alphabétique de nos partenaires soigneusement sélectionnés que nous autorisons à mesurer vos données afin que nous puissions suivre et améliorer nos performances.</p>',
      'preferences-headline': 'Gérer les cookies ',
      'preferences-text':
        "<p> Nous respectons votre droit à la vie privée et vos choix en matière de données. Nous devons traiter certaines de vos informations personnelles quand vous utilisez nos outils, mais nous nous engageons à adopter une approche responsable axée sur les affaires, la technologie et la relation qui nous unit.</p> \n<p>C'est pourquoi nous avons une longueur d'avance afin que votre empreinte numérique soit minime et que vous en gardiez le contrôle, en toute sécurité.</p> \n<p>Par défaut, nous recueillons et traitons des données uniquement lorsque cela s'avère strictement nécessaire. Cependant, si vous souhaitez soutenir notre service et faire en sorte que WeTransfer reste gratuit, nous vous prions de nous autoriser à partager des informations avec nos partenaires publicitaires.</p>",
      'preferences-text-allow-cookies':
        'Autoriser les cookies afin que nous puissions et/ou que nos partenaires puissent :<br><br>',
      'purpose-description-first-intro':
        "Pour faire la promotion de produits sur notre site web et nos applis ainsi qu'en dehors, WeTransfer peut : ",
      'purpose-description-first-list':
        "<ul><li> Recueillir des informations relatives à vos interactions avec notre/nos site(s) web, notamment vos habitudes de clic et de navigation, et (quand c'est possible) combiner ces informations avec les données vous concernant que nous avons enregistrées, telles que l'adresse e-mail de votre comte</li><li>Utiliser les informations que nous recueillons pour vous transmettre des offres et des promotions par e-mail ; sur notre/nos site(s) web et applications ; et sur les sites web et applications de tiers. Il se peut, par exemple, que nous vous fassions la promotion de l'un ou l'autre produit lorsque vous utilisez WeTransfer Pro.</li></ul>",
      'purpose-description-second-intro':
        'Pour faire la promotion de produits sur et en dehors de notre site web et de nos applis, nos partenaires peuvent : ',
      'purpose-description-second-list':
        "<ul><li> Recueillir des informations relatives à vos interactions avec notre/nos site(s) web, notamment vos habitudes de clic et de navigation, et (quand c'est possible) combiner ces informations avec les données vous concernant qu'ils ont enregistrées</li><li>Utiliser les informations qu'ils recueillent pour vous transmettre des offres et des promotions par e-mail ; sur leur(s) site(s) web et applications ; et sur les sites web et applications de tiers avec qui ils collaborent.</li></ul>",
      'purpose-title':
        'Faire la promotion de produits sur notre site web et nos applis, et en dehors',
      'switch-by-partners': 'Par des partenaires',
      'switch-by-we-transfer': 'Par WeTransfer',
      text: '<p> Notre site web utilise des <a href="%{href}">cookies</a> qui contribuent à son bon fonctionnement, nous permettent d\'analyser vos interactions, et nous aident à améliorer nos performances.</p>\n<p>Vous souhaitez aussi autoriser les cookies de nos partenaires publicitaires afin que nous puissions personnaliser les pubs que vous voyez, et faire la promotion de produits offerts par WeTransfer et nos partenaires, tant sur nos sites web et applis qu\'ailleurs ?</p>',
      'text-panel':
        "<p> Notre site web utilise des cookies qui contribuent à son bon fonctionnement, nous permettent d'analyser vos interactions, et nous aident à améliorer nos performances.</p>\n<p>Vous souhaitez aussi autoriser les cookies de nos partenaires publicitaires afin que nous puissions personnaliser les pubs que vous voyez, et faire la promotion de produits offerts par WeTransfer et nos partenaires, tant sur nos sites web et applis qu'ailleurs ?</p>",
      'tos-experiment': {
        'cookie-intro':
          "Le moyen le plus simple d'envoyer des gros fichiers tout en découvrant des œuvres d'art épatantes et des pubs primées.",
        'cookie-text':
          "Notre site utilise des cookies qui contribuent à son bon fonctionnement, nous permettent d'analyser vos interactions, et nous aident à nous améliorer.\nEn acceptant nos cookies, vous nous autorisez à afficher des pubs personnalisées. Vous avez assez entendu le mot cookies ? On arrête, promis (Cookie.)",
      },
      trees: {
        'short-v': {
          subtitle:
            'Notre mission consiste à embellir le monde, grâce à des pubs primées qui ne se mettent pas en travers du chemin et nous permettent de contribuer à la restauration de forêts marines.',
          title: 'Nos cookies protègent la planète',
        },
        subtitle:
          "En acceptant nos cookies, vous nous aidez directement à élargir nos engagements à l'échelle planétaire. Rien que cette année, WeTransfer s'est engagé à planter jusqu'à 175.000 arbres, et nous venons justement de commencer. Vous aurez ainsi un impact positif au simple contact de nos pubs primées. ",
        text: 'Notre site utilise des cookies qui visent à améliorer ses performances, ses services et à mieux saisir vos besoins. En acceptant nos cookies tiers, vous nous permettez, à nos partenaires et nous, de vous proposer des publicités plus pertinentes sur notre/nos site(s) et applis, et en dehors.',
        title: 'Transférez des idées. <b>Transformez le monde.</b>',
      },
    },
    pro_pass_upsell_one: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_collect',
      text: 'Débloquer Collect Pro',
      title: 'Enregistrez et partagez vos inspirations à tout moment',
    },
    pro_pass_upsell_three: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_three',
      text: 'En savoir plus',
      title: 'Votre abonnement comprend désormais Paste® Pro et Collect Pro',
    },
    pro_pass_upsell_two: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_paste',
      text: 'Débloquer Paste® Pro',
      title: 'Transformez vos idées en dossiers de présentation',
    },
    terms_conditions: {
      experiment: {
        text: 'Pour continuer, veuillez accepter nos <a href="/legal/terms" data-route-type="plus">conditions d\'utilisation</a>.',
        title: "Vous y êtes <span class='tc-title-exp'>presque</span>",
        ustitle:
          "Bienvenue à la manière la plus simple d'<span class='tc-title-exp'>envoyer des fichiers volumineux.</span>",
      },
      title: "Tout d'abord...",
      text: 'Veuillez accepter nos <a href="/legal/terms" data-route-type="plus">Conditions d\'utilisation</a> et notre <a href="/legal/privacy" data-route-type="plus">Politique de cookies</a>. Les cookies servent à des fins fonctionnelles et d\'analyses et les cookies tiers uniquement à des fins publicitaires.',
      language: 'Vous utilisez WeTransfer en',
      button: "J'accepte",
    },
    upsell_pricing: {
      text: 'Comparer les forfaits',
      title: 'Vous voulez envoyer de plus gros transferts ?',
      receiving: {
        title: 'Vous souhaitez profiter au maximum de WeTransfer ?',
      },
    },
    welcome: {
      card1:
        "Envoyez et recevez %{transfer_limit} de transferts à l'aide d'un <strong>aperçu partagé</strong>",
      card2:
        'Diffusez vos travaux depuis la <strong>page WeTransfer personnalisée</strong> de votre équipe',
      card3:
        'Collaborez sur des decks sur <strong>Paste®</strong> et des boards sur <strong>Collect</strong>',
      cta: "C'est parti",
      headline: "Vous voilà dans l'équipe, <strong>%{first_name} !</strong>",
      'opt-in':
        'Je souhaite recevoir des histoires sur la créativité et les dernières nouvelles de WeTransfer',
    },
    form: {
      num_files: {
        one: '%{count} fichier · %{remaining} restant',
        other: '%{count} fichiers · %{remaining} restants',
      },
      add_files: 'Chargez vos fichiers',
      more_files: 'Ajouter plus de fichiers',
      available_space: "Ajouter jusqu'à %{size}",
      message: 'Message',
      from: 'Votre adresse e-mail',
      to: 'Envoyer à',
      other_recipients: {
        one: '+%{count} autre',
        other: '+%{count}autres',
      },
      reset_forward: 'Annuler ce transfert',
      drop_files: 'ou glissez et déposez',
      files_count: {
        one: '%{count} fichier ajouté %{fileSize} au total',
        other: '%{count} fichiers ajoutés %{fileSize} au total',
      },
      select_folder: 'Ou sélectionnez un dossier',
    },
    progress: {
      title: 'Transfert en cours...',
      title_finalizing_one: 'Finalizing...',
      title_finalizing_two: 'Almost there...',
      title_finalizing_three: 'One more moment...',
      title_finalizing_four: 'Wrapping up...',
      subtitle_finalizing:
        'Do not close this window until we complete the transfer',
      title_cancel: 'Annuler ce transfert ?',
      uploaded: '%{sent} de %{total} téléchargé',
      remaining: {
        minutes: {
          zero: "Moins d'1 minute restante",
          one: 'Environ 1 minute restante',
          other: 'Environ %{count} minutes restantes',
        },
        hours: {
          one: 'Environ 1 heure restante',
          other: 'Environ %{count} heures restantes',
        },
      },
      document_title: '%{percentage}% - Transfert en cours...',
      meta: {
        email: {
          one_file_one_recipient:
            "Envoi d'%{filesCount} fichier vers %{recipientsCount} personne en cours",
          one_file_other_recipients:
            "Envoi d'%{filesCount} fichier vers %{recipientsCount} personnes en cours",
          other_files_one_recipient:
            'Envoi de %{filesCount} fichiers vers %{recipientsCount} personne en cours',
          other_files_other_recipients:
            'Envoi de %{filesCount} fichiers vers %{recipientsCount} personnes en cours',
        },
        link: {
          one: "Envoi d'%{count} fichier en cours",
          other: 'Envoi de %{count} fichiers en cours',
        },
      },
    },
    complete_link: {
      title: 'Vous avez terminé !',
      text: 'Copier votre lien de téléchargement ou <a href="/transfer/progress">voir le contenu</a>',
      text_copied: 'Le lien a été copié dans votre presse-papiers',
      text_manual_copy:
        'Votre lien est prêt \nAppuyez sur %{shortcut} pour le copier sur votre presse-papier',
      document_title: "C'est fait !",
      text_pre_qr: 'Copy your download link or',
      text_get_qr: 'Get QR code',
      text_see_qr: 'See QR code',
    },
    storage_full_block: {
      information_detail_link: 'a lot of files',
      information_detail_text: 'You’re storing ',
      instruction_detail_link: 'request a storage boost',
      instruction_detail_text: 'Please <b>clean up some old files</b> or ',
      title: 'Hey, big sender',
      cta: 'Clean up',
    },
    complete_forward: {
      title: 'Votre transfert a été effectué',
    },
    complete_email: {
      title: 'Vous avez terminé !',
      text: 'L\'e-mail de transfert a été envoyé, votre transfert sera disponible pendant %{expires}<a href="/transfer/progress">Voir le contenu</a>',
      text_no_expiry:
        'L\'e-mail de transfert a été envoyé. <a href="/transfer/progress"> Voir le contenu</a>',
      document_title: 'Envoyé !',
      text_no_details:
        "L'e-mail de transfert a été envoyé, votre transfert sera disponible pendant %{expires}.",
      team_discovery_title: 'Transfert envoyé !',
      team_discovery_text:
        'Votre transfert sera disponible au téléchargement pendant %{expires}',
    },
    failed: {
      title: "Désolé, une erreur s'est produite",
      text: "Il semblerait que votre transfert n'ait pas fonctionné, veuillez réessayer",
    },
    pending: {
      title: 'On y est presque !',
      subtitle: 'En préparation...',
    },
    downloading: {
      title: 'Réception de vos fichiers en cours...',
      text: 'Nous préparons votre téléchargement',
    },
    downloaded: {
      title: 'Votre téléchargement a commencé',
      text: 'Les fichiers ont été téléchargés, vous les trouverez normalement dans votre dossier Téléchargements',
      download_links:
        'Sachez que les liens de ce Board ne s\'afficheront pas : <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115005062963" rel="external">en savoir plus </a>.',
    },
    expired: {
      title: 'Transfert expiré',
      text: "Désolé, ce transfert a expiré et n'est plus disponible",
    },
    password: {
      title: 'Saisir un mot de passe',
      text: "Vous avez besoin d'un mot de passe pour télécharger ce transfert",
    },
    options: {
      transfer_type: 'Envoyer comme',
      password: 'Mot de passe',
      password_placeholder: 'Écrire',
      expiry: 'Expire après',
      expire_in: {
        '1w': 'une semaine',
        '2w': '2 semaines',
        '1m': '4 semaines',
        never: 'jamais',
        '14d': '2 semaines',
        '28d': '4 semaines',
        '365d': '1 an',
        '7d': 'une semaine',
        '90d': '3 mois',
      },
      email: 'e-mail',
      link: 'lien',
      email_transfer: 'Envoyer un transfert par e-mail',
      transfer_link: 'Obtenir un lien de transfert',
    },
    buttons: {
      transfer: 'Transférer',
      forward: 'Transférer',
      new_transfer: 'Transférer ?',
      cancel: 'Annuler',
      cancel_no: 'Non',
      cancel_yes: 'Oui',
      copy_link: 'Copier le lien',
      ok: 'OK',
      done: 'Un autre ?',
      team_discovery_done: 'Envoyer un nouveau transfert',
      retry: 'Réessayer',
      continue: 'Continuer',
      download: 'Télécharger',
      download_all: 'Tout télécharger',
      back_to_home: "Retour à l'accueil",
      cleanup: 'Consulter les transferts ',
      download_all_files: 'Télécharger tous les fichiers',
      help: "Centre d'aide",
      payment: 'Renouveler maintenant',
      complete_order: 'Payer',
      download_all_experiment: 'Télécharger tout au format .zip',
      download_experiment: 'Télécharger le fichier',
      download_file: 'Télécharger le fichier',
      download_zip: 'Télécharger tout au format zip',
      get_link: 'Recevoir le lien',
      go_to_transfer: 'Voir le transfert',
      openinapp: 'Sauver avec l’appli WeTransfer',
      openinapp_experiment: 'Enregistrer avec l’appli WeTransfer',
      openincollectapp: 'Sauvegarder avec la Collect App',
      get_a_link: 'Obtenir un lien',
    },
    account_expired: {
      text: 'Renouvelez-le maintenant afin de continuer à profiter des avantages de votre compte Pro, ou <a href="#signout">désinscrivez-vous pour utiliser notre service gratuit</a>',
      title: 'Votre compte Pro a expiré',
    },
    invalid: {
      text: "Nous n'avons pas pu trouver vos fichiers",
      title: 'Oups...',
      link: 'En savoir plus',
    },
    outdated_browser: {
      text: 'WeTransfer prend en charge de nombreux navigateurs mais il semble que celui-ci soit obsolète, veuillez mettre à jour votre navigateur',
      title: "Votre navigateur n'est pas à jour",
    },
    spam: {
      text: 'Ce transfert a été signalé comme spam et a été supprimé',
      title: 'Hmm...',
    },
    upsell: {
      text: 'Augmenter la limite',
      limit: "Jusqu'à %{limit} gratuits",
      remaining: '%{remaining} restants',
    },
    upsell_five: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Passer à WeTransfer Pro',
      title:
        'Transférez vos fichiers en toute sécurité grâce à un mot de passe',
    },
    upsell_four: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Passer à WeTransfer Pro',
      title: 'Gérez vos transferts plus facilement et plus efficacement',
    },
    upsell_one: {
      bubble: {
        button: 'Passer à Pro',
        text: "Ajoutez un mot de passe pour protéger vos transferts et déterminez les dates d'expiration.",
        title: "Envie d'une mise à niveau de vos transferts ?",
        text_experiment:
          "Pro permet d'attribuer des mots de passe et des dates d'expiration à vos transferts.",
      },
      href: 'https://facebook.com/wetransfer',
      text: 'WeTransfer sur Facebook',
      title: 'Rejoignez la communauté WeTransfer sur Facebook',
    },
    upsell_three: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Passer à WeTransfer Pro',
      title: 'Personnalisez votre profil WeTransfer',
    },
    upsell_two: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Passer à WeTransfer Pro',
      title: 'De plus gros fichiers et un envoi plus rapide',
    },
    account_inactive: {
      text: 'Validez votre inscription pour commencer avec Pro',
      title: "Votre compte n'est \npas encore actif",
      tiers: {
        text: 'Finalisez votre paiement pour commencer avec %{plan}.',
        title: "Votre abonnement n'est pas encore actif",
      },
    },
    add_items: {
      files: 'Fichiers',
      folders: 'Dossiers',
    },
    complete: {
      open_panel:
        '<a href="/transfer/progress">Voir ce qu\'il y a dedans</a> ?',
    },
    details: {
      button: {
        dismiss: 'Fermer',
      },
    },
    download_preview: 'Télécharger le fichier',
    error: {
      expired: {
        link: "Contacter notre équipe d'assistance.",
        text: 'Oups, votre transfert a déjà expiré.\nUne erreur ?',
        title: 'Transfert expiré',
      },
    },
    item: {
      details: {
        folder: 'Dossier',
      },
    },
    items: {
      zero: 'vide',
      one: '%{count} élément',
      other: '%{count} éléments',
    },
    mobile: {
      button: {
        back: 'Retour',
        cancel: 'Recommencer',
        next: 'Suivant',
      },
      email: {
        title: 'Ajouter des adresses e-mail',
      },
      message: {
        placeholder: 'Ajouter un message au transfert',
        title: 'Message',
      },
      options: {
        email: 'Envoyer un e-mail',
        'email-description':
          'Envoyez votre transfert par un simple e-mail et nous vous avertirons de son téléchargement.',
        link: 'Obtenir un lien',
        'link-description':
          'Transformez vos fichiers en lien et partagez-le comme bon vous semble.',
      },
    },
    recaptcha: {
      button: 'Je suis un véritable être humain',
      text: "Nous devons simplement vérifier que vous n'êtes pas un robot (sans vouloir vous vexer)",
      title: 'Vous y êtes presque !',
    },
    upsell_survey: {
      href: 'https://www.surveymonkey.com/r/2HTSNSZ',
      text: 'Aidez-nous',
      title:
        'Pouvons-nous vous demander quelque chose sur la manière dont vous travaillez ?',
    },
    'verification-code': 'Code de vérification',
    verify: {
      button: 'Démarrer le transfert',
      text: 'Introduisez le code de vérification qui vous a été envoyé',
      title: 'Vous avez un message',
      'verification-code': 'Code de vérification',
    },
    'account-verification-failed': {
      body: 'Nous avons du mal à confirmer votre adresse. Envoyez un nouveau lien pour réessayer.',
      cta: 'Envoyer un nouveau lien ?',
      title: 'Une erreur est survenue',
    },
    'cookie-banner': {
      'button-accept': "D'accord",
      'button-decline': 'Non, merci',
      text: 'Nous utilisons des <a href="%{href}">cookies</a> qui aident le site web à fonctionner, nous permettent d\'analyser la façon dont nos utilisateurs interagissent avec lui et nous aident à l\'améliorer. Souhaitez-vous également autoriser les cookies tiers pour recevoir des publicités personnalisées ?',
    },
    'cookie-manager': {
      analytical: {
        description:
          'Nous utilisons des cookies analytiques pour nous aider à comprendre comment vous utilisez WeTransfer. Ils nous permettent de faire des tests A/B sur de nouvelles fonctionnalités, de faire en sorte que tout fonctionne comme il se doit et de bloquer les bots et les comportements malveillants comme les spams. Ces cookies peuvent comporter des cookies tiers qui traitent des informations personnelles. ',
        title: 'Cookies analytiques',
      },
      clear: {
        'clear-all-cookies': 'Supprimer tous les cookies',
        description:
          'Vous pouvez supprimer toutes vos données de nos cookies. Pour toute demande d\'anonymat permanent, veuillez <a href="mailto:support@wetransfer.com">contacter notre équipe d\'assistance.</a>',
        title: 'Supprimer les cookies',
        warning:
          'Vous serez déconnecté de WeTransfer après avoir effacé les cookies. Cela ne modifiera pas les transferts sur votre compte.',
      },
      functional: {
        description:
          'Nous utilisons des cookies fonctionnels pour vous offrir une expérience transparente sur WeTransfer. Ils sont nécessaires pour utiliser notre service.',
        title: 'Cookies fonctionnels',
      },
      'not-yet-set':
        'Vous ne nous avez pas encore indiqué vos préférences en matière de cookies. Veuillez fermer cette fenêtre et définir vos préférences, vous pourrez toujours les modifier ici par la suite.',
      'save-and-reload': 'Enregistrer les paramètres',
      tracking: {
        description:
          "Nous utilisons des cookies publicitaires dans notre service pour nous aider à évaluer la réussite de nos efforts commerciaux, éditoriaux et promotionnels. Les cookies publicitaires ne sont pas placés sur les pages donnant des informations sur notre marque et nos produits. Les cookies publicitaires nous permettent de savoir si vous avez cliqué sur une publicité particulière, par exemple. Si les cookies placés par des tiers sont aussi placés dans d'autres domaines et sur d'autres sites internet, les annonceurs peuvent suivre votre comportement sur internet, mais WeTransfer ne peut accéder ni utiliser les informations personnelles collectées. Nous vous invitons donc à consulter les politiques de confidentialité des tiers concernés.",
        title: 'Cookies publicitaires',
      },
    },
    'email-verification-resend': {
      account: {
        error: 'Oups, une erreur est survenue',
        'error-email-exists': 'Oups, cette adresse est déjà prise',
        'throttle-error':
          "Waouh, nous vous avons envoyé trop d'e-mails. Veuillez attendre %{throttle_time} avant de demander un nouveau code.",
      },
      back: 'Retour au code de vérification',
      body: "Tout est juste ? Il s'agit de l'adresse e-mail que vous utilisez sur WeTransfer.",
      email: 'E-mail',
      error: 'Oups, une erreur est survenue',
      'error-email-exists': 'Oups, cette adresse est déjà prise',
      submit: 'Renvoyer',
      'throttle-error':
        "Désolé, vous avez fait trop d'essais. Veuillez relancer le transfert.",
      'throttle-error-action': 'Recommencer',
      'throttle-error-link':
        "Waouh, nous vous avons envoyé trop d'e-mails. Veuillez attendre %{throttle_time} avant de demander un nouveau e-mail.",
      title: 'Vérifiez vos e-mails',
    },
    'email-verification-success': {
      body: "Vos destinataires sont maintenant sûrs que vous êtes bien l'expéditeur.",
      free_signup: 'Créer un compte gratuit',
      onboarding_body:
        "Bienvenue au club ! Prêt.e à choisir ton URL et tes fonds d'écran persos ?",
      onboarding_title: 'Bienvenue sur<br/> WeTransfer Pro !',
      send_files: 'Envoyer des fichiers',
      start_onboarding: "C'est parti",
      title: 'Votre compte est validé!',
      upsell: 'Vous ne souhaitez pas vérifier votre adresse à chaque fois ?',
      verified_sender_tooltip:
        'Votre adresse e-mail est vérifiée, et vos destinataires ont ainsi l\'assurance que les transferts ont bien été envoyés par vous. Pour modifier cette adresse e-mail, mettez à jour vos <a href="%{href}">informations personnelles</a>.',
      verified_sender_tooltip_icon:
        "Votre adresse e-mail est vérifiée Cela permet aux gens d'avoir l'assurance que les transferts ont bien été envoyés par vous.",
    },
    'email-verification': {
      account: {
        'error-expiry-time':
          'Oups, ce code est erroné ou a expiré. Les codes ne sont actifs que %{expiry_time} après avoir été envoyés.',
        'error-expiry-time-action': 'Obtenir un nouveau code',
        'throttle-error':
          'Vous avez saisi un code erroné ou ayant expiré trop de fois. Veuillez attendre %{throttle_time} avant de demander un nouveau code.',
      },
      back: 'Retour',
      body: 'Nous avons envoyé un code de vérification à <strong title="%{account_email}">%{account_email}</strong>pour nous assurer qu\'il s\'agit bien de vous. (pensez à vérifier votre dossier de courrier indésirable).',
      body_link:
        'Encore une étape pour vérifier votre identité.<br/><br/>Un lien de vérification a été envoyé à <strong title="%{account_email}">%{account_email}</strong> (si vous ne le voyez pas, vérifiez votre dossier spam).',
      error: 'Oups, ce code est erroné ou a expiré',
      'error-expiry-time':
        'Oups, ce code est erroné ou a expiré. Les codes ne sont actifs que %{expiry_time} après avoir été envoyés.',
      'error-expiry-time-action': 'Obtenir un nouveau code',
      resend: "Vous n'avez pas reçu l'e-mail ?",
      submit: 'Vérification',
      'throttle-error':
        "Désolé, vous avez fait trop d'essais. Veuillez relancer le transfert.",
      'throttle-error-action': 'Recommencer',
      title: 'Confirmez votre adresse e-mail',
      'verification-code': 'Saisissez le code de vérification',
    },
    'force-account-verification': {
      body: "Nous allons vous envoyer un lien pour confirmer l'adresse e-mail que vous utilisez sur WeTransfer.",
      cta: 'Envoyer e-mail',
    },
    'marketing-email-prompt': {
      body: 'Une dernière chose : voudriez-vous recevoir des actualités WeTransfer et les dernières infos sur nos produits ?',
      skip: 'Non merci',
      subscribe: 'Oui, volontiers',
      title: "C'est bien vous !",
    },
    'terms_conditions-no-cookies': {
      text: 'Pour continuer, veuillez accepter nos <a href="/legal/terms?from_home" data-route-type="plus">conditions de service</a>.',
    },
    mobile_web: {
      ios_banner_prompt: "Recevez vos fichiers dans l'application WeTransfer",
      ios_banner_prompt_send: 'Envoyez des fichiers rapidement et facilement',
      tnc_subtitle: 'Le moyen le plus simple d’envoyer de gros fichiers',
    },
  },
  account: {
    legend: {
      plan: 'Forfait',
      save: 'économisez %{amount}%',
      subscription: 'Abonnement',
      summary: 'Récapitulatif de la commande',
      wetransfer_premium: 'WeTransfer Premium',
    },
    'verify-info': 'Pourquoi nous vous demandons de confirmer votre e-mail',
    workspace: {
      default_workspace: 'Espace de travail de %{name}',
      your_workspace: 'Votre espace de travail',
    },
    consent_manager: {
      data_opt_in: {
        title: 'Vos options de confidentialité',
        subtitle: 'Gérer vos données',
        p1: 'Nous voulons toujours vous offrir la meilleure expérience, même en ce qui concerne notre publicité.',
        p2: "Nous aimerions utiliser les données que vous choisissez de partager, comme votre adresse e-mail, afin de comprendre le type de contenu que vous préférez et utiliser cela pour vous montrer (ainsi qu'à d'autres personnes comme vous) les publicités WeTransfer les plus adaptées à vos besoins.",
        p3: "Tout ce que vous créez et partagez avec WeTransfer reste privé pour vous. Nous ne le lisons ni ne l'utilisons à des fins publicitaires.",
        p4: 'Si vous décidez de les partager avec nous, ces informations demeureront toujours sécurisées.',
        control_label:
          "Laissez WeTransfer utiliser les données que vous partagez, comme votre adresse e-mail et votre secteur d'activité, pour personnaliser les publicités que vous voyez sur nos sites web et en dehors.",
      },
      vertical_nav: {
        terms_of_service: 'Conditions de service',
        privacy_and_cookie_statement:
          'Déclaration de confidentialité et de cookies',
        your_privacy_choices: 'Vos options de confidentialité',
        notice_and_takedown_policy: "Politique d'avis et de retrait",
        responsible_disclosure_policy: 'Politique de divulgation responsable',
        advertising_terms_and_conditions:
          'Conditions générales relatives aux publicités',
      },
    },
  },
  account_onboarding_navigation: {
    cta: "Fermer et aller vers l'envoi de fichiers",
  },
  account_start_screen: {
    'collect-description':
      'Gardez toute votre inspiration au même endroit, que ce soit sur votre téléphone, votre PC portable ou votre tablette.',
    'collect-title': 'Aller sur Collect',
    'paste-description':
      "Créez de magnifiques slides en quelques secondes, à l'aide de decks de présentation qui se conçoivent tout seuls.",
    'paste-title': 'Aller sur Paste®',
    title: "Trois outils. Un compte. Une infinité d'options.",
    'transfer-cta': "C'est parti",
    'transfer-description':
      "Mettez-en plein la vue chaque fois que quelqu'un télécharge vos fichiers. Prêt à choisir votre propre URL et vos fonds d'écran persos ?",
    'transfer-title': 'Configurez votre page WeTransfer',
  },
  account_welcome_screen: {
    'pro-title': 'Bienvenue à WeTransfer Pro, <strong>%{name} !</strong>',
    accept: 'Oui, volontiers',
    'accept-short': 'Ok',
    body_1:
      'Souhaitez-vous recevoir des histoires qui parlent de créativité et les dernières nouvelles de WeTransfer ?',
    body_2: '(Vous pouvez toujours vous désabonner par la suite)',
    decline: 'Non, merci',
    'decline-short': 'Non merci',
    title: 'Bienvenue sur WeTransfer, <strong>%{name}</strong>',
  },
  cookie_wall_paid: {
    button: {
      accept: 'Accepter les cookies',
      deny: 'Refuser les cookies',
      manage: 'Gérer les cookies',
    },
    description:
      "Nous utilisons des cookies ordinaires et des cookies analytiques afin d'assurer une excellente expérience, ainsi que des cookies tiers à des fins publicitaires.",
    heading:
      "Découvrez le moyen le plus simple d'envoyer des fichiers volumineux",
    snippet: 'Bienvenue sur WeTransfer',
  },
  dropzone: {
    pro: {
      title: '<span>Déposez</span> vos<br>fichiers',
    },
    title: 'Déposez vos fichiers',
    text: 'Chargez vos fichiers ou vos dossiers en les déposant dans cette fenêtre',
  },
  form: {
    account: {
      billing_address: 'Adresse de facturation',
      billing_cta: 'Aller vers le paiement',
      billing_title: 'Informations de facturation',
      legend: {
        details: 'Vos données de facturation',
        coupon_code: 'Ajouter un code promotionnel',
        free_plus: 'Obtenez votre compte gratuit Pro',
      },
      label: {
        year_label: 'Annuel',
        year_sublabel: 'Meilleure affaire : %{discount_rate}% de réduction!',
        month_label: 'Mensuel',
        month_sublabel: 'Paiement récurrent',
        email: 'Adresse e-mail',
        not_required: '(facultatif)',
        current_password: 'Mot de passe actuel',
        new_password: 'Nouveau mot de passe',
        repeat_new_password: 'Confirmer le nouveau mot de passe',
        password: 'Mot de passe',
        password_confirm: 'Confirmer mot de passe',
        full_name: 'Nom complet',
        company: 'Société',
        street_and_number: 'Adresse',
        city: 'Ville',
        zipcode: 'Code postal',
        country_code: 'Pays',
        vat_number: 'TVA',
        coupon_code: 'Code promotionnel',
        family_name: 'Nom',
        given_name: 'Prénom',
        state_code: 'État',
      },
      description: {
        password:
          'Sélectionnez un mot de passe qui contient au moins 6 caractères',
        vat_number:
          "Nous facturons aux entreprises situées aux Pays-Bas une TVA de 21 %. Si votre entreprise se trouve dans un autre pays de l'UE, saisissez les coordonnées de votre entreprise et son numéro d'identification fiscale européenne pour supprimer la TVA de votre facture.\n\nDans le cas oú votre entreprise est située en dehors de l'UE, nous avons tout de même besoin de vos informations de facturation, mais nous ne facturons pas de TVA.",
      },
      error: {
        email: {
          blank: 'Veuillez saisir votre adresse e-mail',
          invalid: 'Veuillez saisir une adresse e-mail valide',
          taken: 'Cette adresse email est déjà utilisée',
          taken_login:
            'Il semble que vous ayez déjà un compte. <a class="form-notification__message-link" href="%{login_url}">Vous voulez vous connecter ?</a>',
        },
        current_password: {
          invalid: 'Mot de passe non reconnu',
          blank: 'Veuillez saisir votre mot de passe actuel',
        },
        password: {
          blank: 'Veuillez saisir votre nouveau mot de passe',
          too_short: 'Le mot de passe doit contenir au moins 6 caractères',
        },
        password_confirm: {
          blank: 'Veuillez confirmer votre nouveau mot de passe',
          confirm: 'Les mots de passe ne correspondent pas',
        },
        full_name: {
          blank: 'Veuillez saisir votre nom complet',
          too_short: 'Oups, votre nom doit comporter au moins trois caractères',
        },
        street_and_number: {
          blank: 'Veuillez saisir votre adresse',
        },
        city: {
          blank: 'Veuillez saisir votre ville',
        },
        zipcode: {
          blank: 'Veuillez saisir votre code postal',
        },
        country_code: {
          inclusion: "Vérifiez l'orthographe, ou essayez un autre pays",
          blank: 'Veuillez saisir votre pays',
        },
        vat_number: {
          vat_number: 'Veuillez saisir un numéro de TVA valide',
        },
        terms_of_service: {
          accepted:
            "Veuillez accepter nos Conditions d'utilisation pour continuer",
        },
        no_results: "Vérifiez l'orthographe, ou essayez un autre pays",
        convert: {
          expired:
            "Désolé, ce transfert a déjà expiré et ne peut être sauvegardé. Saviez-vous que les utilisateurs de WeTransfer Pro peuvent garder leurs transferts aussi longtemps qu'ils le souhaitent ? En savoir plus ici.",
        },
        coupon_code: {
          coupon_code: 'Veuillez saisir un code promotionnel valide',
        },
        no_state_results: 'Est-ce bien un État ?',
      },
      complete_order: 'Valider votre commande',
      terms_conditions:
        'J\'accepte les <a href="/legal/terms" %{options}>Conditions d\'utilisation</a> et j\'ai lu la <a href="/legal/privacy" %{options}>Déclaration concernant la vie privée et les cookies</a>',
      signup_for_plus: 'Enregistrez-vous pour WeTransfer Pro',
      account_cta: "C'est parti",
      signup_for_account: 'Créez un compte WeTransfer',
      'email-verification-not-verified-link':
        'Veuillez vérifier votre adresse e-mail. Vérifiez l\'e-mail que nous vous avons envoyé ou <button type="button" class="button button--link">demandez-en un nouveau</button>.',
      'email-verification-resend': {
        error: 'Oups, une erreur est survenue',
        info: 'Nouveau code envoyé ! Consultez votre boîte de réception',
        info_link: 'Nouvel e-mail envoyé ! Consultez votre boîte de réception',
        'throttle-error':
          "Waouh, nous vous avons envoyé trop d'e-mails. Veuillez attendre %{throttle_time} avant de demander un nouveau code.",
      },
      'force-account-verification': {
        message:
          "Veuillez vérifier votre adresse e-mail pour confirmer qu'il s'agit bien de vous.",
      },
      marketing_opt_in:
        'Je souhaite recevoir les actualités de WeTransfer et des informations sur les nouveaux produits',
      sso: {
        header: 'Informations personnelles',
        password_reset: {
          button: 'Envoyer un e-mail',
          instructions:
            "Besoin d'un petit changement (de mot de passe) ? Nous sommes là pour vous. Cliquez simplement sur le bouton ci-dessous et nous enverrons un e-mail à <span>%{email}</span> avec un lien pour changer votre mot de passe.",
          success: 'E-mail envoyé ! Consultez votre boîte de réception.',
          title: 'Changer votre mot de passe',
        },
        wrong_user: "Ce n'est pas vous ? Se déconnecter",
      },
    },
    payment_cancel: {
      submit: 'Confirmer',
      client_request:
        "Un client avait demandé l'utilisation de WeTransfer, mais je n'en ai plus besoin",
      different_tool: "J'ai trouvé un autre outil",
      extra_features:
        'Il me faut des fonctionnalités qui ne sont pas proposées',
      not_enough_storage: "L'espace de stockage ne me suffit pas",
      not_often_large_files:
        "Je n'envoie pas de fichiers volumineux assez souvent",
      other: 'Autre',
      other_more: 'Pouvez-nous nous en dire plus ?',
      skip: "Passer et annuler l'abonnement",
      temp_project:
        "Je n'avais besoin d'envoyer des fichiers volumineux que pour un projet temporaire",
      too_expensive: "Je trouve que c'est trop cher",
    },
    payment_cancel_reason: {
      skip: 'Je ne souhaite pas faire part de mes commentaires',
    },
    profile: {
      label: {
        profile_title: 'Nom de profil',
        wallpaper_link: "Site web où relier les fonds d'écran",
      },
      error: {
        subdomain_name: {
          too_short:
            'La concision est une bonne chose, mais votre URL WeTransfer doit contenir au moins 2 caractères',
          domain_name: 'Désolé, ce nom est déjà pris',
          invalid:
            'Héhé, dommage - votre URL WeTransfer ne peut contenir que des lettres et des chiffres (et un tiret entre les caractères)',
          taken: 'Désolé, ce nom est déjà pris',
        },
        subdomain: {
          too_short: 'Ajoutez au moins 2 caractères',
          too_long: 'Héhé, ne dépassez pas 63 caractères',
          invalid:
            'Héhé, dommage - votre URL WeTransfer ne peut contenir que des lettres et des chiffres (et un tiret entre les caractères)',
          domain_name: 'Cette URL est déjà prise',
          taken: 'Cette URL est déjà prise',
        },
        default_recipient_email: {
          invalid: 'Veuillez saisir une adresse e-mail valide',
        },
        wallpaper_link: {
          invalid: 'Veuillez saisir une adresse web valide',
        },
      },
      success: {
        subdomain: {
          updated: 'Votre URL a été mise à jour',
          available: 'Bonne nouvelle, cette URL est disponible',
        },
      },
      change_background: "Télécharger un fond d'écran",
      delete_avatar: "Supprimer l'avatar",
      delete_background: "Supprimer le fond d'écran",
      description: {
        title: 'Limitez-vous à 150 caractères pour que rien ne soit coupé',
        wallpaper_link:
          'Vos papiers peints redirigeront vers cette adresse web',
        recipient_email_locked:
          "Les fichiers envoyés par le biais de votre profil ne seront adressés qu'à cette adresse e-mail",
      },
      upload_avatar: 'Télécharger un avatar',
      use_email_background_checkbox_label:
        'Utiliser ce papier peint pour tous les transferts envoyés via mon profil',
      account_email_checkbox: "Afficher l'e-mail sur le profil",
      default_recipient_email_info:
        'Vous pouvez modifier cette adresse e-mail dans vos <a href="/account">détails personnels</a>',
      change_subdomain: {
        message:
          'Modifier l’URL pour <a href="%{url}">%{subdomain}.wetransfer.com</a> ? Votre précédente URL deviendra immédiatement disponible.',
        confirm: "Oui, modifier l'URL",
        cancel: 'Retour',
      },
    },
    fill_in_password:
      'Veuillez saisir votre mot de passe pour enregistrer ces modifications',
    select_all: 'Tout sélectionner',
    deselect_all: 'Tout désélectionner',
    save_changes: 'Enregistrer les modifications',
    save: 'Enregistrer',
    submitting: 'Validation en cours',
    cancel: 'Annuler',
    forward: 'Transférer',
    proceed: 'Continuer',
    delete: 'Supprimer',
    onboarding: {
      placeholder: {
        subdomain_name: 'choisissez-bien-votre-nom',
      },
      validated: {
        subdomain_name: 'Bonne nouvelle, ce domaine est disponible',
      },
    },
    confirm_leave:
      'Êtes-vous certain de vouloir quitter cette page ? Vous perdrez vos modifications non sauvegardées.',
    unsaved_changes:
      'Quitter la page ? Toutes les modifications non enregistrées seront perdues.',
    contact: {
      add_contact: 'Ajouter un contact',
      error: {
        email: {
          duplicate:
            'Cette adresse e-mail est déjà dans votre liste de contact',
          invalid: 'Veuillez saisir une adresse e-mail valide',
        },
      },
      label: {
        company: 'Société',
        email: 'Adresse e-mail',
        name: 'Nom',
      },
    },
    error: {
      current_password: {
        blank: 'Veuillez saisir votre mot de passe actuel',
        invalid: 'Mot de passe non reconnu',
      },
      email: {
        blank: 'Veuillez saisir votre adresse e-mail',
        duplicate: 'Cette adresse e-mail est déjà dans votre liste de contacts',
        invalid: 'Veuillez saisir une adresse e-mail valide',
        taken: 'Cette adresse e-mail est déjà utilisée',
      },
    },
    leave: 'Quitter',
    resetpassword: {
      button: {
        request_submit: 'Envoyer un e-mail',
        reset_submit: 'Sauvegarder',
      },
      label: {
        confirm_new_password: 'Confirmer le nouveau mot de passe',
        email: 'Adresse e-mail',
        new_password: 'Nouveau mot de passe',
      },
      legend: {
        request_description:
          'Vous êtes bloqué ? Nous allons vous envoyer des instructions afin de redéfinir votre mot de passe et vous redonner votre accès.',
        request_title: 'Vous avez oublié votre mot de passe ?',
        reset_description:
          'Saisissez un nouveau mot de passe pour pouvoir vous reconnecter',
        reset_title: 'Définir un nouveau mot de passe',
        request_description_success_or_article:
          'Si vous avez un compte WeTransfer, nous vous avons envoyé des instructions pour réinitialiser votre mot de passe. Consultez cet <a href="https://wetransfer.zendesk.com/hc/en-us/articles/360033809331" rel="external">article du centre d\'aide</a> si vous n\'avez pas reçu d\'e-mail dans les dix prochaines minutes.',
      },
    },
    signin: {
      button: {
        submit: 'Se connecter',
      },
      label: {
        email: 'Adresse e-mail',
        password: 'Mot de passe',
        remember_me: 'Se souvenir de moi',
      },
      link: {
        forgot_password: 'Mot de passe oublié ?',
      },
      title: 'Se connecter',
    },
    stay_on_page: 'Rester sur la page',
    close_panel: 'Fermer',
    go_back: 'Retour',
    labels: {
      email: 'Adresse e-mail',
    },
    plan: {
      change: {
        month: 'Mensuelle (%{price} %{currency})',
        title: 'Changer de formule',
        year: 'Annuelle (%{price} %{currency})',
      },
      change_plan: 'Modifier la formule de paiement',
      month: {
        copy: 'Facturation récurrente',
        label: 'Mensuel',
        'label-payment': 'Paiement mensuel',
        'sub-label': 'Une facture chaque mois',
        title: 'WeTransfer Pro : paiement mensuel',
      },
      title: "Donnez à vos idées le traitement optimal qu'elles méritent",
      year: {
        discount: 'Économisez %{rate}% (que du bonus)',
        'label-payment': 'Paiement annuel',
        'sub-label': "Cela représente 17% d'économies. Rien que ça !",
        title: 'WeTransfer Pro : paiement annuel',
      },
      your_order: 'Votre commande',
    },
    save_and_continue: 'Enregistrer et continuer',
    upgrade: null,
    fill_in_password_two_factor_authentication:
      'Saisissez votre mot de passe pour continuer',
  },
  mobileweb: {
    'app-upsell': {
      cta: {
        false: 'Pas maintenant',
        true: "Ouvrir dans l'appli WeTransfer",
      },
      headline: 'Pourquoi ne pas penser plus grand ?',
      headline2: "Visualisez les fichiers dans l'appli ?",
      subheader: 'Envoyez et recevez 200 Go avec WeTransfer Pro',
      subheader2:
        'Prévisualisez les fichiers avant de les télécharger. Envoyez et recevez des transferts, suivez les téléchargements et recevez des notifications.',
    },
  },
  panel: {
    warning: {
      account_expired_subtitle_tier:
        'Renouvelez votre abonnement maintenant pour continuer à profiter de tous les avantages liés à votre compte %{tier}',
      account_expired_title_tier: 'Votre compte %{tier} a expiré',
      account_inactive_title_tier: 'Prêt à passer à %{tier}',
      account_inactive_action: 'Oui, continuer',
      account_inactive_subtitle:
        "Plus qu'une étape, puis c'est fini. Vous avez changé d'avis ? Pas de souci—",
      account_inactive_title: 'Prêt à devenir Pro ?',
      account_subscription_action: 'Renouveler maintenant',
      account_subscription_expired: 'Votre compte Pro a expiré',
      account_subscription_subtitle:
        "Renouvelez-le maintenant pour conserver vos transferts, fonds d'écran personnalisés et adresse web personnalisée. Veuillez noter que dans le cas contraire, ils seront supprimés prochainement!",
      account_expired_action: 'Renouveler maintenant',
      account_expired_subtitle:
        "Renouvelez-le maintenant pour continuer de profiter de tous les avantages d'un compte Pro",
      account_expired_title: 'Votre compte Pro est arrivé à expiration',
      expired_transfer_subtitle:
        "Ces fichiers ne sont plus disponibles. Vous pouvez supprimer les informations de l'aperçu du transfert <a>ici</a>.",
      expired_transfer_title: 'Ce transfert a expiré',
      account_email_verify_logged_out:
        'Veuillez vous connecter pour vérifier votre e-mail',
      account_inactive_sublink: 'annulez votre commande.',
      email_unverified_mobile_cta: 'Prêt pour la vérification',
      email_unverified_text:
        "Nous vous avons envoyé un code de vérification à l'adresse %{email}. <a href='%{href}'>Ce n'est pas vous ?</a>",
      email_unverified_text_link:
        "Nous avons envoyé un e-mail à %{email}. <a href='%{href}'>Ce n'est pas vous ?</a>",
      email_unverified_title: 'Veuillez vérifier votre adresse e-mail',
      'force-account-verification': {
        body: "Nous allons vous envoyer un lien pour vérifier qu'il s'agit bien de vous.",
      },
      'receiving-email':
        'Attention ! Nous avons remplacé %{receiving_email} dans votre profil. Cela signifie que les nouveaux transferts n\'apparaîtront dans votre aperçu que s\'ils sont envoyés à %{account_email}. Vous pouvez modifier ce paramètre en mettant à jour vos <a href="/account">détails personnels</a> à tout moment.',
    },
    design:
      "Vous avez surement remarqué que nous avons effectué quelques changements ici ! La plupart sont des choses que vous souhaitiez voir. Vous pouvez dès à présent profiter de ces nouveautés et du site amélioré. N'hésitez pas à nous faire part de vos futures remarques ici.",
    loading_error:
      'Désolé, il semble que cette page rencontre actuellement des problèmes de chargement. \nNous réessaierons, ou <a href="%{path}"> tentez de rafraîchir la page</a> vous-même.',
    redesign_notice:
      'Vous avez surement remarqué que nous avons <a href="/about/redesign">effectué quelques changements</a> par ici! La plupart sont des éléments que vous souhaitiez voir. Vous pouvez dès à présent profiter de ces nouveautés et du site amélioré. N\'hésitez pas à <a href="/contact" rel="external">nous faire part de vos futures remarques ici<a/>.',
    return_to: 'Retour aux %{pageName}',
    close: 'Fermer la fenêtre',
    cookie: {
      accept: 'OK',
      text: 'Nous utilisons des cookies. Pensez à lire les <a href="/legal/terms"> conditions juridiques</a>.',
    },
    footer: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      jobs: 'Emplois',
      press: 'Presse',
      terms: 'Conditions',
      twitter: 'Twitter',
      youtube: 'YouTube',
    },
  },
  upsell_tiers: {
    button: 'Évoluer',
    free_limit:
      'Vous ne pouvez pas envoyer plus de 2 Go à la fois. Vous voulez envoyer de plus gros transferts ?',
    compare_plans: {
      button: 'Comparer les forfaits',
      text: 'Vous pouvez mettre à niveau votre forfait afin de transférer plus de 2 Go à la fois.',
      title: "Vous avez d'autres fichiers à envoyer ?",
    },
    mobile: {
      cta: 'En savoir plus',
      header: 'Tirez le meilleur parti de WeTransfer',
      upsell_enjoy: "Obtenez plus d'espace de stockage",
      upsell_one: 'Envoyez de plus gros transferts',
      upsell_two: 'Personnalisez votre page WeTransfer',
    },
    pro_limit:
      'Vous ne pouvez pas envoyer plus de 200 Go à la fois. Vous voulez transférer sans limite de taille ?',
  },
  upsell_tiers_one: {
    text: "Vous voulez que vos transferts soient assortis à des mots de passe et des dates d'expiration ?",
  },
  upsell_tiers_three: {
    text: 'Vous voulez envoyer des transferts vers plus de %{email_limit} adresses e-mail à la fois ?',
    title: "C'est un de trop",
  },
  browser: {
    assets_failed: {
      text: 'Nous n\'avons pas pu charger certaines parties importantes de notre site web. Elles ont peut-être été bloquées par les paramètres de votre pare-feu, de votre proxy ou de votre navigateur. \nEssayez de rafraîchir la page ou contactez-nous via notre <a href="https://wetransfer.zendesk.com" rel="external">centre d\'aide</a>.',
      title: 'Oups...',
    },
    javascript_needed:
      "Vous devez disposer d'un navigateur compatible avec JavaScript pour utiliser WeTransfer",
  },
  languages: {
    en: 'Anglais',
    nl: 'Pays-Bas',
  },
  shortcuts: {
    cmd_alt_l: '⌘-Alt-L',
    cmd_j: '⌘-J',
    cmd_c: '⌘-C',
    cmd_shift_j: '⌘-Shift-J',
    control_alt_l: 'Ctrl-Alt-L',
    control_j: 'Ctrl-J',
    control_c: 'Ctrl-C',
  },
  discount: {
    billing_page: {
      legal_notice:
        "Cette offre est disponible jusqu'au %{end_date}. La réduction s'applique sur votre première année de %{user_tier}, après quoi l'abonnement sera renouvelé au tarif plein de %{yearly_amount}/%{billing_period}.",
    },
    modal: {
      title: '%{discount_amount} % de réduction sur le forfait Pro annuel',
      subtitle: 'Code de réduction : %{coupon_code_name}',
      text_content:
        "C'est ça. C'est ça, le deal. Nous vous offrons une réduction de %{discount_amount} % sur un forfait Pro annuel.",
      argument: {
        size_limit: 'Envoyez et recevez 200 Go de transferts de fichiers',
        storage_size: 'Profitez de 1 To de stockage',
        unlimited_review: 'Créez des avis illimités',
      },
      cta_label: 'Réclamez votre réduction',
      dismiss_label: 'Pas maintenant',
    },
    banner: {
      title:
        'Bénéficiez de %{discount_amount} % de réduction sur WeTransfer Pro pendant un an : notre meilleure offre à ce jour',
      cta_label: 'Mettre à niveau',
    },
    pricing_page: {
      pill_label: '%{coupon_code_name} – %{discount_amount}% off',
    },
  },
  drawer: {
    first_viewing: {
      title: 'Faites équipe et transférez avec %{first_recipient_email}',
      subtitle:
        'Invitez votre équipe à envoyer et recevoir des transferts grâce à votre forfait %{user_plan}.',
      list: {
        overview_item: 'Aperçu commun des transferts',
        storage_limit_item:
          'Stockage partagé de %{storage_limit} supplémentaire par personne',
        branding_item: "Logo de l'image de marque partagée",
        subscription_item: 'Abonnement partagé et facturation',
      },
      cta: 'Inviter une équipe',
      dismiss_button: "Pas aujourd'hui",
    },
    second_viewing: {
      title: 'Faites équipe avec ${first_recipient_email} et transférez',
      subtitle:
        'Invitez votre équipe à envoyer et recevoir des transferts grâce à votre forfait %{user_plan}.',
      list: {
        overview_item: 'Aperçu commun des transferts',
        storage_limit_item:
          'Stockage partagé de %{storage_limit} supplémentaire par personne',
        branding_item: "Logo de l'image de marque partagée",
        subscription_item: 'Abonnement partagé et facturation',
      },
      cta: 'Inviter une équipe',
      dismiss_button: 'Masquer pour toujours',
    },
  },
  external_links: {
    android_app: 'https://we.tl/android',
    ios_app: 'https://we.tl/iosapp',
    facebook: 'https://www.facebook.com/wetransfer',
    homerun: 'https://wetransfer.com/jobs',
    instagram: 'https://www.instagram.com/WeTransfer/',
    twitter: 'https://twitter.com/WeTransfer',
    prco: 'https://wetransfer.pr.co',
    youtube: 'https://www.youtube.com/WeTransfer',
  },
  notification: {
    update_account: 'Votre compte a été mis à jour',
    update_password: 'Votre mot de passe a été mis à jour',
    update_subscription: 'Votre abonnement a été mis à jour',
    update_profile_success: 'Votre profil a été mis à jour',
    link_copied: 'Ce lien a été copié dans votre presse-papier',
    copy_link_manual: 'Lien sélectionné, copiez-le en utilisant %{shortcut}',
    delete_transfer_success: 'Ce transfert a été supprimé',
    delete_transfers_success: 'Les transferts ont été supprimés',
    update_expiry_success: "La date d'expiration a été mise à jour",
    onboarding_success:
      "Pour avoir un aperçu de votre transfert, vos contacts, vos paramètres de profil et d'autres éléments, c'est ici",
    add_contact_success: 'Ce contact a été ajouté',
    edit_contact_success: 'Ce contact a été mis à jour',
    remove_contact_success: 'Ce contact a été supprimé',
    already_signed_in: 'Vous êtes connecté',
    cancel_subscription_success:
      'Nous regrettons de vous voir partir - votre inscription a été résiliée.',
    collect_app_banner_desc:
      'Prévisualiser, sauvegarder et gérer des fichiers à partir de la Collect App',
    contact_added_confirmation: 'Le contact a été ajouté à votre transfert',
    contact_recipient_locked_text:
      "Cette page permet au propriétaire de recevoir des fichiers. Les envoyez-vous à quelqu'un d'autre ?",
    forward_ready: 'Votre transfert est prêt à être transféré',
    mobile_app_banner_desc:
      "Visualiser, sauver et gérer des fichiers depuis l'appli",
    mobile_app_banner_title: "Sauver dans l'appli",
    reactivate_subscription_success:
      'Heureux de vous retrouver ! Votre compte est réactivé. ',
    refresh_transfer_upload_lost:
      'Êtes-vous certain de vouloir annuler le téléchargement actuel ?',
    update_payment_success: 'Les détails ont bien été mis à jour. Tada !',
    update_user: 'Vos coordonnées ont été mises à jour',
    current_team_notification:
      "Vous utilisez pour l'instant %{plan} en tant que %{currentTeam}",
    display_name_updated: 'Titre mis à jour !',
    download_started:
      'Votre téléchargement a commencé. Les fichiers ont été téléchargés, vous les trouverez normalement dans votre dossier Téléchargements.',
    logged_out:
      'Il semble que vous ayez été déconnecté depuis un autre navigateur. Veuillez vous reconnecter.',
    project_delete:
      'Supprimer <strong>%{projectName}</strong> et tous les fichiers ajoutés ?',
    project_delete_success: '<strong>%{projectName}</strong> a été supprimé',
    password_changed: 'Mot de passe modifié',
    password_removed: 'Mot de passe supprimé',
  },
  alert: {
    confirm_cancel_upload_image:
      'Êtes-vous certain de vouloir annuler le téléchargement actuel ? ',
    cancel_recipient_locked: 'Annuler',
    cancel_refresh_transfer_upload_lost: 'Non',
    confirm_refresh_transfer_upload_lost: 'Oui',
    go_to_transfer: 'Voir le transfert',
    redirect_recipient_locked: 'Oui',
    stay: 'Rester sur la page',
    cancel_project_delete: 'Annuler',
    confirm_project_delete: 'Supprimer',
  },
  force_update:
    'Des choses incroyables vous attendent ! Veuillez <a href="/" onClick=\'javascript:window.location.reload();\'>rafraîchir votre navigateur</a> afin de vous assurer que vous utilisez la dernière version de WeTransfer.',
  user: {
    already_logged_in:
      'Vous êtes déjà connecté, êtes-vous certain de vouloir réinitialiser votre mot de passe ?',
    roles: {
      admin: 'administrateur',
      owner: 'propriétaire',
      user: 'utilisateur',
    },
    sign_out_and_reset: 'Me déconnecter et réinitialiser le mot de passe',
  },
  click_here: 'Cliquez ici',
  cookiebox: {
    notice:
      '<bold>Vous êtes actuellement connecté(e)</bold>, vous serez déconnecté(e) après avoir supprimé vos cookies. Les anciens transferts sur votre compte ne seront pas affectés.',
  },
  notice: {
    general_issues:
      'Tout ne se passe pas comme prévu ? Tenez bon, nous y remédions <a target="_blank" href=%{link}>le plus vite possible</a>',
    transfer_issues:
      'Des difficultés avec votre transfert ? Tenez bon, nous y remédions <a target="_blank" href=%{link}>le plus vite possible</a>',
    verification:
      'Bonjour, il faut que vous <a href="/account">confirmiez votre e-mail</a>',
  },
  site: {
    name: 'WeTransfer',
    titles: {
      about: 'À propos | WeTransfer',
      advertise: 'Faites votre publicité chez nous | WeTransfer',
      apps: 'Applications gratuites pour Mac, iOS et Android | Applis WeTransfer',
      forgot_password: 'Réinitialiser le mot de passe | WeTransfer Pro',
      help: 'Comment envoyer de gros fichiers | Aide WeTransfer',
      home: 'Partager des gros fichiers facilement et gratuitement | WeTransfer',
      plus: 'Montez en gamme pour envoyer de plus gros fichiers | WeTransfer Pro',
      sign_in: 'Se connecter | WeTransfer Pro',
      sign_up: "S'inscrire | WeTransfer Pro",
      upgrade: 'Monter en gamme | WeTransfer Pro',
      pricing:
        "Tarification | WeTransfer - Envoyez des fichiers volumineux et partagez des photos en ligne - Jusqu'à 2 Go gratuits",
    },
    descriptions: {
      help: 'Need WeTransfer tech support? Find out how to send large files in our Quick Help section or get in touch.',
      social_help: "Vous n'avez toujours pas trouvé ce que vous cherchez ?",
    },
  },
  splash: {
    footer: {
      or: 'ou',
      send_files: 'Je souhaite juste envoyer mes fichiers',
      no_thanks: 'Non merci',
    },
    heading: {
      line_1_free:
        "WeTransfer est la meilleure manière d'envoyer des fichiers volumineux",
      line_2_free: 'Profitez davantage de WeTransfer',
      free_account:
        "Nous sommes heureux de vous revoir. Vous souhaitez faire votre retour dans les règles de l'art ?",
    },
    plan: {
      plus: {
        feature_10: 'Personnalisez vos e-mails',
        feature_11: "Stockez jusqu'à %{plus_storage_limit}",
        feature_12: "Fixez la date d'expiration des transferts",
        feature_13: 'Protégez vos transferts par mot de passe',
        feature_7: 'Personnalisez votre profil',
        feature_8: "Créez votre propre carnet d'adresses",
        feature_9: 'Personnalisez votre URL WeTransfer',
      },
      free_account: {
        cta: "S'inscrire gratuitement",
        feature_1: 'Pas de stockage',
        feature_2: "Envoyez jusqu'à %{free_transfer_limit}",
        feature_3: 'Renvoyer et supprimer des transferts',
        heading: 'Compte WeTransfer',
        price_label: 'Gratuit pour toujours',
      },
      pro: {
        cta: 'Obtenir WeTransfer Pro',
        feature_1: "%{storage_limit_pro} d'espace de stockage",
        feature_2: "Envoyez et recevez jusqu'à %{transfer_limit_pro}",
        feature_2_unlimited:
          'Envoyer et recevoir des fichiers sans limite de taille',
        feature_3: 'Renvoyez et supprimez des transferts',
        feature_4: 'Protégez vos transferts par mot de passe',
        feature_5: 'Votre propre page Pro et URL',
        heading: 'WeTransfer',
      },
    },
  },
  tooltip: {
    team_discovery: {
      title: 'Ajouter %{recipient} à votre équipe ?',
      text_content:
        "Les membres de l'équipe peuvent accéder aux transferts de chacun grâce à un espace de stockage et une image de marque partagés. Cela n'annulera pas votre transfert.",
      cta: 'Allons-y',
    },
  },
  transfer_link: {
    buttons: {
      copied: 'Lien copié',
      copy: 'Copier le lien',
      copy_again: 'Copier à nouveau',
    },
    labels: {
      share: 'Partager ce transfert',
    },
  },
  callout: {
    pill: {
      pro_onboarding: 'CONSEIL DE PRO',
    },
    'portals-onboarding': {
      'first-viewing': {
        cta: 'Découvrez les portails',
        dismiss: 'Pas maintenant',
        text: "Vous pouvez inviter des clients et des collaborateurs à visualiser vos travaux et sélectionner leurs favoris à l'aide de <strong>portails</strong>. Adieu, les échanges interminables par e-mail.",
        title: 'Besoin de feedback - et vite - pour vos travaux ?',
      },
      'second-viewing': {
        cta: 'Essayer les portails maintenant',
        dismiss: 'Ne plus afficher ce message',
        text: "Obtenez des réactions rapides et partagez des nouvelles versions - tout au même endroit. Avec les <strong>portails</strong>, vous pouvez continuer à travailler en douceur, de l'analyse à la révision jusqu'au mot de la fin.",
        title: 'Vous avez envoyé votre travail. Et maintenant ?',
      },
    },
    pro_onboarding: {
      admin: {
        cta: 'Aller vers Image de marque',
        text_2: 'Voulez-vous ajouter vos propres vidéos ou images ?',
      },
      individual: {
        cta: 'Configurer la page',
        text: "Faites forte impression chaque fois que quelqu'un télécharge vos fichiers : ajoutez des vidéos ou des images et choisissez votre propre URL.",
        title: 'Plantez le décor avec votre propre page WeTransfer',
      },
      invitee: {
        cta: "J'ai compris",
        text_1:
          'Avec la page WeTransfer personnalisée de votre équipe, vous ferez forte impression à chaque partage.',
        text_2:
          "Vous pouvez changer le fond d'écran de votre équipe à tout moment dans <strong>Image de marque</strong>.",
        title: "Exposez vos travaux (d'équipe)",
      },
      not_now: 'Pas maintenant',
    },
  },
  cue: {
    inline: {
      teams: {
        onboarding: {
          transfers: {
            received: {
              mini: {
                branding_incomplete: {
                  cta: 'Configurer la page',
                  premium: {
                    text: 'Tout le monde peut vous envoyer des transferts sans limite de taille depuis la page WeTransfer de votre équipe.',
                  },
                  text: 'Tout le monde peut vous envoyer %{transfer_limit_pro} de transferts depuis la page de votre équipe',
                },
                premium: {
                  transfer_link: {
                    text: 'Tout le monde peut vous envoyer des transferts sans limite de taille depuis %{custom_link}',
                  },
                },
                transfer_link: {
                  text: "Tout le monde peut vous envoyer jusqu'à %{transfer_limit_pro} de transferts depuis %{custom_link}",
                },
              },
              premium: {
                text: 'Tout le monde peut vous envoyer des transferts sans limite de taille depuis la page WeTransfer de votre équipe - il vous suffit transmettre ce lien.',
              },
              regular: {
                cta: "J'ai compris",
                text: 'Depuis la page WeTransfer de votre équipe, tout le monde peut vous envoyer <strong>%{transfer_limit_pro}</strong> de transferts. Il suffit de transmettre ce lien.',
                title: 'Un seul endroit pour tout ce que votre équipe reçoit',
              },
            },
            sent: {
              regular: {
                cta: "J'ai compris",
                text: "Bienvenue dans l'aperçu partagé des transferts envoyés de votre équipe. Vous pouvez suivre les téléchargements, changer les dates d'expiration, et même modifier ou supprimer les transferts des autres - il est néanmoins préférable de les avertir au préalable !",
                title: 'Gérez les transferts de votre équipe',
              },
            },
          },
        },
      },
    },
  },
  feature_banner: {
    pro: 'WeTransfer Plus devient WeTransfer Pro avec 1 TB de stockage — soit 10 fois plus. <a href="/transfers">En savoir plus.</a>',
  },
  refer_friend: {
    title: 'Parrainer des amis',
    account: {
      description:
        'Nous allons vous donner, à vous et votre ami, 10 $ chacun lors de votre inscription à WeTransfer Pro ou Premium. Partagez votre lien de parrainage pour être récompensé(e) en cartes prépayées, dons à des œuvres caritatives, ou cartes cadeaux de centaines de partenaires.',
    },
    window: {
      link: 'Obtenir un lien de parrainage',
      send_another: 'Continuer',
      text: 'Nous allons vous donner, à vous et votre ami, <strong>10 $</strong> chacun lors de votre inscription à WeTransfer Pro ou Premium.',
      title: 'Parrainer un ami',
      title_2: "pour l'envoi de transferts.",
    },
    message: {
      success:
        "Vous avez un excellent ami ! Inscrivez-vous à WeTransfer Pro ou Premium, et vous obtiendrez chacun une carte prépayée, un don à une œuvre caritative ou une carte cadeau d'une valeur de 10 $.",
      self: 'Oh non, ce lien de parrainage ne semble pas correct. Veuillez demander un nouveau lien à votre ami afin de recevoir 10 $ lors de votre inscription à WeTransfer Pro ou Premium.',
      fallback:
        'Oh non, ce lien de parrainage ne semble pas correct. Veuillez demander un nouveau lien à votre ami afin de recevoir 10 $ lors de votre inscription à WeTransfer Pro ou Premium.',
      expired: 'Désolé, votre lien de parrainage a expiré.',
      dismiss: 'Fermer',
    },
  },
  order_summary: {
    coupon: {
      link: 'Appliquer un code promo',
      input_placeholder: 'Code promo',
      button_label: 'Appliquer',
      error_message:
        'Désolé, ce code ne peut être utilisé que pour économiser sur un abonnement %{billing_period}.',
      generic_error_message:
        "Désolé, ce code n'est pas compatible avec cet abonnement",
      input_error_message: "Hmm, ce code n'est pas valide.",
      pill_label: {
        percentage: '-%{percentage} %',
      },
    },
    total: 'Total',
  },
  mobile_verify: {
    title: 'Vous êtes fin prêt(e)',
    subtitle:
      "Votre adresse e-mail a été vérifiée. Vous pouvez désormais utiliser l'application pour envoyer et recevoir des transferts.",
    cta: "Ouvrir l'application WeTransfer",
  },
  pricing_panel: {
    current_solo_workspace_information:
      'Votre forfait actuel de <b>%{formattedintervaltotal}</b> / %{subscriptioninterval} sera renouvelé automatiquement le <b>%{autorenewalattempt}</b>',
    current_team_workspace_information:
      'Votre forfait actuel de <b>%{formattedTeamWorkspaceCost}</b> / %{subscriptioninterval} (%{membercount} x %{tieramount}) sera renouvelé automatiquement le <b>%{autorenewalattempt}</b>',
    next_payment_date:
      'Votre prochaine date de paiement est le <b>%{recurring_billing_date}</b>',
    upgrade_price: '<b>%{totalprice}</b> / %{interval}',
    team_upgrade_calculation: '(%{membercount} membres x %{tierprice})',
    premium_title: 'WeTransfer Premium',
    premium_feature_one: 'Pas de limites de taille sur les transferts',
    premium_feature_two: 'Stockage illimité',
    premium_feature_three: 'Portails et avis illimités',
    premium_feature_four:
      'Voir <a class="all-benefits-link" href="%{all_benefits_href}">tous les avantages</a>',
    premium_switch_cta_text: 'Passer à Premium',
    pill_text: 'Forfait actuel',
    member_count: '%{membercount} membres',
    see_all_benefits: 'Voir tous les avantages du forfait',
    pending_downgrade_current_subscription:
      "Votre abonnement à l'espace de travail a été annulé et prendra fin le <b>%{cancellation_date}</b>.",
    pending_downgrade_reactivate_text:
      "Vous avez changé d'avis ? Pas de panique, il est facile de tout remettre en place.",
    pending_downgrade_reactivate_cta: 'Réactiver Pro',
    pending_downgrade_payment: "Vous n'avez aucun paiement à venir",
    update_payment_cta: 'Mettre à jour les détails de paiement',
    cancel_plan:
      "Si vous annulez votre abonnement, vous pouvez accéder à votre espace de travail %{planName} jusqu'au %{subscriptionRenewalDate}. ",
    cancel_expiry_text:
      'Votre espace de travail rétrogradera alors au forfait gratuit et vos transferts existants expireront au bout de 28 jours.',
    pending_payment_text:
      'Pour consulter les informations relatives à votre forfait et au paiement, veuillez effectuer votre paiement ou annuler votre commande.',
    learn_more: 'En savoir plus sur les forfaits et les tarifs',
  },
  time: {
    days: {
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche',
    },
    months: {
      january: 'Janvier',
      february: 'Février',
      march: 'Mars',
      april: 'Avril',
      may: 'Mai',
      june: 'Juin',
      july: 'Juillet',
      august: 'Août',
      september: 'Septembre',
      october: 'Octobre',
      november: 'Novembre',
      december: 'Décembre',
    },
    remaining: {
      minutes: {
        zero: "Moins d'une minute restante",
        one: 'Environ 1 minute restante',
        other: 'Environ %{count} minutes restantes',
      },
      hours: {
        one: 'Environ 1 heure restante',
        other: 'Environ %{count} heures restantes',
      },
    },
  },
  download: {
    shortcut: 'Pressez %{command} pour voir la progression du téléchargement',
    shortcuts: {
      control_j: 'Ctrl-J',
      control_alt_l: 'Ctrl-Alt-L',
      cmd_shift_j: '&#8984;-Shift-J',
      cmd_j: '&#8984;-J',
      cmd_alt_l: '&#8984;-Alt-L',
    },
  },
  upload: {
    title: "Envoyer jusqu'à %{size}",
    progress: {
      busy: 'Transfert en cours...',
    },
    buttons: {
      add: 'Ajouter fichiers',
      transfer: 'Transfert',
      forward: 'Expédier',
      add_ios6: 'Ajouter des photos et vidéos',
      add_ios7: 'Ajouter des photos',
    },
    forward: {
      done: 'Envoi réussi',
    },
    friend_email: {
      title: "Email de l'ami",
      more: "Ajouter d'autres amis",
    },
    your_email: {
      title: 'Votre email',
    },
    message: {
      title: 'Message',
    },
    done: {
      title: 'Transfert terminé',
      link: 'Copiez votre lien de téléchargement :',
      copied: {
        title: 'Copié !',
        text: 'Le lien de téléchargement a été copié.',
      },
    },
    more_html: "Ajouter d'autres fichiers<span>(%{size})</span>",
    too_many_recipients:
      "Apparemment, il y a trop d'adresses mail. Rappel : l'espace est limitée à %{count} personnes à la fois.",
    completed: '%{size} de %{total} terminé',
    addresses: {
      one: '%{count} adresse',
      other: '%{count} adresses',
      remove: 'Voulez-vous supprimer %{address} des précédents destinataires ?',
    },
    ads: {
      plus: {
        title: "Obtenez encore<br />plus d'avantages Wetransfer avec Pro",
        text: "<ul><li>Des téléchargements de très grandes tailles</li><li>Des transferts personnalisés avec vos propres fonds d'écrans</li><li>Des transferts de données protégés par mot de passe</li><li>Un stockage à long terme</li></ul><p><a target='_blank' href='/pro?trk=inapp'>En savoir plus</a></p>",
      },
      plus2: {
        title:
          'Impressionnez avec votre propre page de téléchargement personnalisée',
        text: "<p>Utilisez votre propre fond d’écran et votre URL personnalisée de WeTransfer (votrenom.wetransfer.com) pour impressionner vos destinataires.</p><p><a target='_blank' href='/pro?trk=inapp'>En savoir plus</a></p>",
      },
      plus3: {
        title: 'Gérez vos transferts plus astucieusement',
        text: "<p>Ce transfert sera effacé au bout d'une semaine. Mais avec WeTransfer Pro, vous pouvez stocker indéfiniment, transférer et supprimer instantanément, sans avoir à renouveler le transfert.</p><p><a target='_blank' href='/pro?trk=inapp'>En savoir plus</a></p>",
      },
      plus4: {
        title: 'Obtenez une protection supplémentaire pour vos fichiers',
        text: "<p>Avec WeTransfer Pro, vous pouvez protéger vos fichiers importants et confidentiels avec un mot de passe. Ainsi, ils ne tomberont jamais dans de mauvaises mains.</p><p><a target='_blank' href='/pro?trk=inapp'>En savoir plus</a></p>",
      },
      facebook: {
        title: 'Rejoignez la communauté Wetransfer sur Facebook',
        text: "<p>Obtenez les dernières nouveautés, gagnez des prix, découvrez de nouveaux artistes et des interviews et bien plus encore.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>En savoir plus</a>",
      },
      flipflops: {
        title: 'Free flipflops by WeTransfer',
        text: "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>",
      },
    },
    errors: {
      only_email:
        "Désolé, seul l'email est accepté pour renvoyer un transfert.",
      connect_twitter:
        "Votre compte Twitter n'est pas encore connecté à WeTransfer.",
      connect_facebook:
        "Votre compte Facebook n'est pas encore connecté à WeTransfer.",
      transferproblems: {
        title: 'Problème de transfert',
        text: "Désolé de casser votre joie mais ce transfert s'est mal passé.",
      },
      limitreached: {
        title: 'Limite de stockage',
        text: "Vous avez atteint la limite de 100 Go. Supprimez d'anciens transferts pour envoyer de nouveaux fichiers",
      },
      blocked: {
        title: 'Problème de transfert',
        text: "L'ordinateur refuse. Désolé, vous êtes bloqué par WeTransfer.",
      },
      upload_error: {
        title: 'Problème de transfert',
        text: "Désolé de casser votre joie mais ce transfert s'est mal passé.",
      },
      unavailable: {
        title: 'Erreur de transfert',
        text: 'Désolé, ce transfert a déjà été supprimé donc il ne peut pas être expédié.',
      },
      startswithdot: {
        title: 'Mince',
        text: 'Un (ou plusieurs) nom de vos fichier  contient un point. Cela ne fonctionnera pas. Veuillez renommer le fichier(s) puis tentez de les ajouter à nouveau.',
      },
      startswithspace: {
        title: 'Mince',
        text: 'Un (ou plusieurs) nom de fichier commence par un espace. Cela ne fonctionnera pas. Veuillez renommer le ou les fichiers puis tentez de les ajouter à nouveau.',
      },
      containsreturn: {
        title: 'Mince',
        text: 'Un (ou plusieurs) nom de fichier contient le caractère de la touche retour. Nous ignorons comment vous y êtes parvenu mais cela ne fonctionnera pas. Veuillez renommer le fichier(s) et essayez de les ajouter à nouveau.',
      },
      alreadyinlist: {
        title: 'Zut',
        text: "L'un de vos fichiers  a le même nom qu'un autre fichier déjà sélectionné. Modifiez-le un peu!",
      },
      transfertoobig: {
        title: 'Oh, oh',
        text: 'Toutes nos excuses, mais il est impossible de transférer plus de %{upload_limit}Go en une fois.',
      },
      filetoobig: {
        title: 'Oh, oh',
        text: 'Toutes nos excuses, mais il est impossible de transférer plus de %{upload_limit}Go en une fois.',
      },
      zerobytes: {
        title: 'Youpi',
        text: 'Un (ou plusieurs) de vos fichiers est vide ou illisible.',
      },
      ioerror: {
        title: 'Échec',
        text: 'Un (ou plusieurs) de vos fichiers  est illisible ou dépasse %{upload_limit}Go. Cela ne fonctionnera pas.',
      },
      filenametoolong: {
        title: 'Zut',
        text: 'Un (ou plusieurs) de vos fichiers a un nom supérieur à 250 caractères. Nous ne pouvons pas accepter des nom de fichier aussi longs, veuillez le renommer.',
      },
      nofolders: {
        title: 'Oh, oh',
        text: "Désolé, le téléchargement de dossiers ne fonctionne pas encore. Essayez en les compressant d'abord.",
      },
      nofiles: {
        title: 'Mince',
        text: "Vous n'avez pas encore ajouté de nouveaux fichiers.",
      },
      norecipients: {
        title: 'Zut !',
        text: "Vous avez probablement oublié d'entrer des adresses de destinataires.",
      },
      toomanyrecipients: {
        title: 'Zut',
        text: 'Trop de destinataires.',
      },
      bigmessage: {
        title: 'Oups',
        text: "Votre message est plus long qu'un roman. Raccourcissez-le.",
      },
      nosender: {
        title: 'Vraiment ?',
        text: "Vous avez oublié d'entrer votre propre adresse mail. Comment avez-vous pu?",
      },
      senderemailinvalidformat: {
        title: 'Oh, oh',
        text: "Votre adresse mail semble incorrecte. Vérifiez bien l'orthographe !",
      },
      probablynotcopied: {
        title: 'Oups',
        text: "Il semble que vous n'avez pas copié le lien.",
      },
      recipientemailinvalidformat: {
        title: 'Mince',
        text: "Vous avez mal saisi l'une des adresses mail de vos amis.",
      },
      requiresdefaultrecipient: {
        title: 'Uh-oh',
        text: 'Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again.',
      },
      containsbackslash: {
        title: 'Zut',
        text: "Un (ou plusieurs) de vos de fichiers a un nom qui contient une barre oblique inversée. Ce caractère n'est pas accepté, veuillez renommer les fichiers sans barre oblique inversée.",
      },
      title: 'Oups',
      text: "iOS7 ne vous permet pas d'envoyer des vidéos sur notre site, mais en utilisant notre fantastique application  <a href='%{wetransfer_ios_app_store_url}'> WeTransfer </a>, vous pouvez!",
    },
    tips: {
      maxfilesize_tip: {
        title: 'Astuce',
        text: "Vous pouvez envoyer jusqu'à 2 Go par transfert. Mieux encore : vous pouvez transférer aussi souvent que vous le désirez.",
      },
      maxfilesize_oldbrowser_tip: {
        title: 'Important',
        text: "Votre compte Pro peut transférer jusqu'à 20 Go par transfert, mais votre navigateur vous en empêche. <a href=/questions/33>Cliquez ici pour de plus amples informations.</a>",
      },
      recipients_tip: {
        title: 'Astuce',
        text: "Vous pouvez entrer jusqu'à %{email_limit} adresses de destinataires. Si vous voulez juste un lien de téléchargement, cliquez sur le bouton de partage ci-dessous.",
      },
      default_recipient: {
        title: 'Tip',
        text: 'To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you.',
      },
      sender_tip: {
        title: 'Astuce',
        text: 'Lâchez votre adresse mail perso pour que nous puissions vous notifier quand les fichiers sont téléchargés.',
      },
      expire_tip: {
        title: 'Astuce',
        text: "À présent, vous pouvez changer la date d'expiration de vos transferts Pro.",
      },
      message_tip: {
        title: 'Astuce',
        text: "Vous souhaitez ajouter un message à vos fichiers ? C'est votre chance, mais vous n'êtes pas obligé.",
      },
      share_tip: {
        title: 'Astuce',
        text: 'Changez la manière de partager vos fichiers. Envoyez-les par mail ou saisissez un lien de téléchargement.',
        text_plus:
          'Changez la manière de partager vos fichiers. Envoyez-les par mail, Twitter, Facebook ou saisissez un lien de téléchargement.',
      },
      download: {
        title: '',
        chrome:
          "Le téléchargement ne fonctionne plus comme avant. Maintenant, nous téléchargeons tous les fichiers via le navigateur, vous ne pourrez donc plus voir la progression dans WeTransfer et l'on ne vous demandera peut-être plus où ce fichier sera stocké. La progression du téléchargement sera visible en bas de la fenêtre du navigateur et votre fichier sera stocké par défaut dans votre dossier de téléchargement. <a href='/questions/24' target='_blank'>Apprenez à changer cela</a>.",
        firefox:
          "Le téléchargement ne fonctionne plus comme avant. Maintenant, nous téléchargeons tous les fichiers via le navigateur, vous ne pourrez donc plus voir la progression dans WeTransfer et l'on ne vous demandera peut-être plus où ce fichier sera stocké. La progression du téléchargement sera visible en bas de la fenêtre du navigateur et votre fichier sera stocké par défaut dans votre dossier de téléchargement. <a href='/questions/24' target='_blank'>En savoir plus</a>.",
        safari:
          "Le téléchargement ne fonctionne plus comme avant. Maintenant, nous téléchargeons tous les fichiers via le navigateur, vous ne pourrez donc plus voir la progression dans WeTransfer et l'on ne vous demandera peut-être plus où ce fichier sera stocké. La progression apparaîtra en haut à droite de la fenêtre navigateur et votre fichier sera stocké par défaut dans le dossier de téléchargement. <a href='/questions/24' target='_blank'>En savoir plus</a>.",
        old_explorer:
          "Le téléchargement ne fonctionne plus comme avant. Maintenant, nous téléchargeons tous les fichiers via le navigateur, vous ne pourrez donc plus voir la progression dans WeTransfer et l'on ne vous demandera peut-être plus où ce fichier sera stocké. Vous pourriez aussi voir une alerte de sécurité apparaître en haut de la fenêtre de votre navigateur. <a href='/questions/24' target='_blank'>En savoir plus</a>.",
        explorer:
          "Le téléchargement ne fonctionne plus comme avant. Maintenant, nous téléchargeons tous les fichiers via le navigateur, vous ne pourrez donc plus voir la progression dans WeTransfer et l'on ne vous demandera peut-être plus où ce fichier sera stocké. La progression du téléchargement sera visible en bas de la fenêtre du navigateur et votre fichier sera stocké par défaut dans votre dossier de téléchargement. <a href='/questions/24' target='_blank'>En savoir plus</a>.",
        settings:
          "Vous pouvez changer l'endroit de la configuration par défaut du téléchargement dans les paramètres de votre navigateur.",
      },
    },
  },
  warnings: {
    unsaved_changed:
      'You have made changes to your Channel. Are you sure you want to leave this page without saving?',
    forwarding:
      'Renvoyer ce transfert va effacer le formulaire, êtes-vous sûr?',
    is_busy: 'Désolé, nous ne pouvons pas faire ceci maintenant',
  },
  mobile_app: {
    remember_choice: 'Ne plus afficher ce message',
    uploader: {
      description:
        "Notre site n'est pas optimisé pour les téléphones mobiles actuellement. Mais nous avons une magnifique application mobile.",
      app_name: 'WeTransfer',
      download: "Télécharger l'application",
      continue: 'Continuer vers WeTransfer.com',
    },
    downloader: {
      title: 'Vos fichiers sont prêts à être téléchargés',
      description_ios:
        'Nous avons regroupé vos fichiers dans un fichier zip. Vous aurez besoin d\'une application pour extraire et afficher les fichiers. Nous pensons que <a href="https//itunes.apple.com/us/app/winzip/id500637987?mt=8">Winzip</a> est une application idéale pour cela.',
      description_android:
        'Nous avons regroupé vos fichiers dans un fichier zip. Vous aurez besoin d\'une application pour extraire et afficher les fichiers. Nous pensons que <a href="https//play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en">ES File Explorer</a> est une application idéale pour cela.',
      continue: 'Compris',
    },
  },
};
